import MessengerWorkspace from "../../messenger/MessengerWorkspace";
import { mergeWindow } from "../../messenger/messengerClient";
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { connectLiveKitAudioCall, createCallTone } from '../../services/chatCallClient';
import { chatApi, messengerClient } from '../../services/chatApi';
import './ChatsPage.css';

const MOBILE_BREAKPOINT = 767;
// Desktop call ownership is now in the shared workspace, above all chat tabs.
const LEGACY_CALL_CONTROLS = false;
const CALL_PROTOCOL_LIVEKIT = 'livekit-v1';
const ACTIVE_CALL_STATUSES = new Set(['ringing', 'accepted']);
const TERMINAL_CALL_STATUSES = new Set(['rejected', 'missed', 'ended', 'failed']);
const CONNECTED_PARTICIPANT_STATUS = 'connected';

const UI_TEXT = {
    today: '\u0421\u0435\u0433\u043e\u0434\u043d\u044f',
    yesterday: '\u0412\u0447\u0435\u0440\u0430',
    participant: '\u0423\u0447\u0430\u0441\u0442\u043d\u0438\u043a',
    personalChat: '\u041b\u0438\u0447\u043d\u044b\u0439 \u0447\u0430\u0442',
    newChat: '\u041d\u043e\u0432\u044b\u0439 \u0447\u0430\u0442',
    membersSuffix: '\u0443\u0447\u0430\u0441\u0442\u043d\u0438\u043a\u043e\u0432',
    personalDialog: '\u041b\u0438\u0447\u043d\u044b\u0439 \u0434\u0438\u0430\u043b\u043e\u0433',
    noMessages: '\u041d\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439',
    noMessagesYet: '\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439 \u043f\u043e\u043a\u0430 \u043d\u0435\u0442',
    noChats: '\u041f\u043e\u043a\u0430 \u043d\u0435\u0442 \u0447\u0430\u0442\u043e\u0432',
    selectChat: '\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0447\u0430\u0442',
    voiceMessage: '\u0413\u043e\u043b\u043e\u0441\u043e\u0432\u043e\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435',
    photoOrVideo: '\u0424\u043e\u0442\u043e \u0438\u043b\u0438 \u0432\u0438\u0434\u0435\u043e',
    file: '\u0424\u0430\u0439\u043b',
    attachment: '\u0412\u043b\u043e\u0436\u0435\u043d\u0438\u0435',
    voice: '\u0413\u043e\u043b\u043e\u0441\u043e\u0432\u043e\u0435',
    messages: '\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f',
    message: '\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435',
    search: '\u041f\u043e\u0438\u0441\u043a',
    searchMessages: '\u041f\u043e\u0438\u0441\u043a \u043f\u043e \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f\u043c',
    findMessages: '\u041d\u0430\u0439\u0442\u0438 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f',
    searchAction: '\u041d\u0430\u0439\u0442\u0438',
    searching: '\u041f\u043e\u0438\u0441\u043a...',
    noResults: '\u041d\u0438\u0447\u0435\u0433\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e',
    noResultsYet: '\u0420\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u043e\u0432 \u043f\u043e\u043a\u0430 \u043d\u0435\u0442',
    chatMedia: '\u041c\u0435\u0434\u0438\u0430 \u0447\u0430\u0442\u0430',
    noItems: '\u041d\u0435\u0442 \u044d\u043b\u0435\u043c\u0435\u043d\u0442\u043e\u0432',
    settings: '\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u0447\u0430\u0442\u0430',
    loadingSettings: '\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u043d\u0430\u0441\u0442\u0440\u043e\u0435\u043a...',
    chatTitle: '\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u0447\u0430\u0442\u0430',
    chatTitleOptional: '\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 (\u043e\u043f\u0446\u0438\u043e\u043d\u0430\u043b\u044c\u043d\u043e)',
    muteNotifications: '\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0443\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u0438\u044f',
    compactBubbles: '\u041a\u043e\u043c\u043f\u0430\u043a\u0442\u043d\u044b\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f',
    autoDownloadPhotos: '\u0410\u0432\u0442\u043e\u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0444\u043e\u0442\u043e',
    autoDownloadVideos: '\u0410\u0432\u0442\u043e\u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0432\u0438\u0434\u0435\u043e',
    autoDownloadFiles: '\u0410\u0432\u0442\u043e\u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0444\u0430\u0439\u043b\u043e\u0432',
    autoDownloadVoice: '\u0410\u0432\u0442\u043e\u0437\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0433\u043e\u043b\u043e\u0441\u043e\u0432\u044b\u0445',
    saveSettings: '\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438',
    saving: '\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u0438\u0435...',
    media: '\u041c\u0435\u0434\u0438\u0430',
    files: '\u0424\u0430\u0439\u043b\u044b',
    links: '\u0421\u0441\u044b\u043b\u043a\u0438',
    voiceTab: '\u0413\u043e\u043b\u043e\u0441\u043e\u0432\u044b\u0435',
    attachFiles: '\u041f\u0440\u0438\u043a\u0440\u0435\u043f\u0438\u0442\u044c \u0444\u0430\u0439\u043b\u044b',
    recordVoice: '\u0417\u0430\u043f\u0438\u0441\u0430\u0442\u044c \u0433\u043e\u043b\u043e\u0441\u043e\u0432\u043e\u0435',
    stopRecording: '\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u0438\u0442\u044c \u0437\u0430\u043f\u0438\u0441\u044c',
    inviteParticipant: '\u041f\u0440\u0438\u0433\u043b\u0430\u0441\u0438\u0442\u044c \u0443\u0447\u0430\u0441\u0442\u043d\u0438\u043a\u0430',
    openSettings: '\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438',
    openMedia: '\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043c\u0435\u0434\u0438\u0430',
    jumpToLatest: '\u041a \u043f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u043c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f\u043c',
    backToChats: '\u041d\u0430\u0437\u0430\u0434 \u043a \u0447\u0430\u0442\u0430\u043c',
    send: '\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c',
    save: '\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c',
    sent: '\u041e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e',
    read: '\u041f\u0440\u043e\u0447\u0438\u0442\u0430\u043d\u043e',
    edited: '\u0438\u0437\u043c\u0435\u043d\u0435\u043d\u043e',
    deletedMessage: '\u0421\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u0443\u0434\u0430\u043b\u0435\u043d\u043e',
    editMessage: '\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c',
    deleteMessage: '\u0423\u0434\u0430\u043b\u0438\u0442\u044c',
    messageActions: '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u0441 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435\u043c',
    cancelEdit: '\u041e\u0442\u043c\u0435\u043d\u0430',
    editingMessage: '\u0420\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f',
    editMessageError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435',
    deleteMessageError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435',
    deleteMessageConfirm: '\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u044d\u0442\u043e \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435?',
    close: '\u0417\u0430\u043a\u0440\u044b\u0442\u044c',
    loading: '\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430...',
    loadingMessages: '\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439...',
    showPrevious: '\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c \u043f\u0440\u0435\u0434\u044b\u0434\u0443\u0449\u0438\u0435',
    createChat: '\u0421\u043e\u0437\u0434\u0430\u0442\u044c \u0447\u0430\u0442',
    newChatTitle: '\u041d\u043e\u0432\u044b\u0439 \u0447\u0430\u0442',
    creating: '\u0421\u043e\u0437\u0434\u0430\u043d\u0438\u0435...',
    addParticipant: '\u041f\u0440\u0438\u0433\u043b\u0430\u0441\u0438\u0442\u044c',
    adding: '\u0414\u043e\u0431\u0430\u0432\u043b\u0435\u043d\u0438\u0435...',
    phone: '\u0422\u0435\u043b\u0435\u0444\u043e\u043d',
    browserNoVoice: '\u0417\u0430\u043f\u0438\u0441\u044c \u0433\u043e\u043b\u043e\u0441\u043e\u0432\u044b\u0445 \u043d\u0435 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044f \u0432 \u044d\u0442\u043e\u043c \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435',
    loadSettingsError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u0447\u0430\u0442\u0430',
    saveSettingsError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438',
    searchError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0432\u044b\u043f\u043e\u043b\u043d\u0438\u0442\u044c \u043f\u043e\u0438\u0441\u043a',
    openMessageError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043a\u0440\u044b\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435',
    mediaError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u043c\u0435\u0434\u0438\u0430',
    uploadError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0432\u043b\u043e\u0436\u0435\u043d\u0438\u0435',
    recordError: '\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0447\u0430\u0442\u044c \u0437\u0430\u043f\u0438\u0441\u044c',
    call: 'Звонок',
    audioCall: 'Аудиозвонок',
    incomingCall: 'Входящий звонок',
    outgoingCall: 'Исходящий звонок',
    callFrom: 'Звонит',
    callTo: 'Звоним',
    callRinging: 'Звоним...',
    callConnecting: 'Подключение...',
    callInProgress: 'В разговоре',
    callEnded: 'Звонок завершен',
    callFailed: 'Не удалось подключиться',
    callNoMic: 'Нужен доступ к микрофону',
    answerCall: 'Ответить',
    declineCall: 'Отклонить',
    endCall: 'Завершить',
    muteCall: 'Выключить микрофон',
    unmuteCall: 'Включить микрофон',
    enableCallSound: 'Включить звук',
    callSoundBlocked: 'Браузер заблокировал звук. Нажмите, чтобы включить.',
};

function getIsMobileViewport() {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= MOBILE_BREAKPOINT;
}

function parseRouteChatId(value) {
    if (!value) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function formatChatError(error, fallback) {
    const raw = String(error?.details?.error || error?.message || '');
    const status = error?.response?.status || error?.status || error?.details?.status;

    if (/timeout|exceeded|ECONNABORTED/i.test(raw)) return 'Не удалось обновить чаты: сервер долго не отвечает';
    if (status === 401 || status === 403) return 'Нет доступа к этому чату';
    if (status === 404 || /not_found|forbidden/i.test(raw)) return 'Чат не найден или у вас нет доступа';
    if (/network/i.test(raw)) return 'Нет соединения. Проверьте интернет';

    return raw || fallback;
}

function getMuteUntilIso(period) {
    if (period === 'forever') return null;

    const date = new Date();
    if (period === 'hour') {
        date.setHours(date.getHours() + 1);
        return date.toISOString();
    }
    if (period === 'eight-hours') {
        date.setHours(date.getHours() + 8);
        return date.toISOString();
    }

    date.setDate(date.getDate() + 1);
    date.setHours(9, 0, 0, 0);
    return date.toISOString();
}

function getMuteStatusLabel(preferences) {
    if (!preferences?.isMuted) return 'Уведомления включены';
    if (!preferences.mutedUntil) return 'Отключены навсегда';

    const date = new Date(preferences.mutedUntil);
    if (Number.isNaN(date.getTime())) return 'Уведомления отключены';
    return `Отключены до ${date.toLocaleString('ru-RU', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}`;
}

function formatTime(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}

function formatChatListTime(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';

    const now = new Date();
    if (d.toDateString() === now.toDateString()) {
        return formatTime(iso);
    }

    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'short' });
}

function formatDateLabel(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (d.toDateString() === now.toDateString()) return UI_TEXT.today;
    if (d.toDateString() === yesterday.toDateString()) return UI_TEXT.yesterday;

    return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

function getDayKey(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

function buildParticipantLabel(participant) {
    const label = participant?.displayName?.trim() || participant?.phone;
    if (label) return label;
    return UI_TEXT.participant;
}

function buildChatName(chat) {
    if (chat?.title && chat.title.trim()) return chat.title.trim();

    const labels = (chat?.participants || [])
        .filter((participant) => !participant.isMe)
        .map(buildParticipantLabel)
        .filter(Boolean);

    if (!labels.length) return UI_TEXT.personalChat;
    return labels.join(', ') || UI_TEXT.newChat;
}

function buildChatMeta(chat) {
    if (!chat) return '';

    const nonMe = (chat.participants || []).filter((participant) => !participant.isMe);
    if (chat.isGroup) {
        return `${chat.participantCount ?? chat.participants?.length ?? 0} ${UI_TEXT.membersSuffix}`;
    }

    return nonMe[0]?.phone || nonMe[0]?.displayName || UI_TEXT.personalDialog;
}

function isActiveCall(call) {
    return call?.protocol === CALL_PROTOCOL_LIVEKIT && ACTIVE_CALL_STATUSES.has(call.status);
}

function upsertCalls(prev, incoming) {
    const list = Array.isArray(incoming) ? incoming : [incoming].filter(Boolean);
    if (!list.length) return prev;

    const map = new Map(prev.map((call) => [String(call.id), call]));
    list.forEach((call) => {
        if (!call?.id) return;
        const key = String(call.id);
        if (TERMINAL_CALL_STATUSES.has(call.status)) map.delete(key);
        else if (isActiveCall(call)) map.set(key, call);
    });

    return Array.from(map.values()).sort((a, b) => Number(a.id) - Number(b.id));
}

function getCallParticipant(call, userId) {
    if (!call || userId == null) return null;
    return (call.participants || []).find((participant) => participant.userId === userId) || null;
}

function getCallParticipantLabel(participant) {
    return buildParticipantLabel(participant);
}

function getCallPeerLabel(call, chat, myUserId) {
    if (!call) return buildChatName(chat);
    if (call.initiatorUserId !== myUserId) {
        return getCallParticipantLabel(getCallParticipant(call, call.initiatorUserId)) || buildChatName(chat);
    }

    const peers = (call.participants || [])
        .filter((participant) => participant.userId !== myUserId)
        .map(getCallParticipantLabel)
        .filter(Boolean);
    if (peers.length === 1) return peers[0];
    if (peers.length > 1) return `${peers.length} участников`;
    return buildChatName(chat);
}

function hasRemoteConnected(call, myUserId) {
    return (call?.participants || []).some(
        (participant) => participant.userId !== myUserId && participant.status === CONNECTED_PARTICIPANT_STATUS
    );
}

function isIncomingRingingCall(call, myUserId) {
    if (!isActiveCall(call) || myUserId == null || call.initiatorUserId === myUserId) return false;
    const me = getCallParticipant(call, myUserId);
    return !me || ['invited', 'ringing', 'connecting'].includes(me.status);
}

function formatCallError(error) {
    const raw = String(error?.details?.error || error?.message || '');
    if (/NotAllowed|Permission|permission|microphone|mic/i.test(raw)) return UI_TEXT.callNoMic;
    if (/livekit_not_configured/i.test(raw)) return 'LiveKit не настроен';
    return raw || UI_TEXT.callFailed;
}

function getInitials(label) {
    const value = (label || '').trim();
    if (!value) return 'CH';

    const parts = value.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
}

function buildAvatar(chat) {
    const label = buildChatName(chat);
    return { label, initials: getInitials(label) };
}

function sortChatsByActivity(items) {
    return [...items].sort((a, b) => {
        if (Boolean(a.isPinned) !== Boolean(b.isPinned)) return a.isPinned ? -1 : 1;
        if (a.isPinned && b.isPinned) {
            return +new Date(b.pinnedAt || b.updatedAt) - +new Date(a.pinnedAt || a.updatedAt);
        }
        return +new Date(b.updatedAt) - +new Date(a.updatedAt);
    });
}

function upsertMessages(prev, incoming) {
    if (!incoming.length) return prev;

    const map = new Map();
    prev.forEach((message) => map.set(message.id, message));
    incoming.forEach((message) => map.set(message.id, message));

    return Array.from(map.values()).sort((a, b) => a.id - b.id);
}

function mergeMessageIntoChat(chat, message, myUserId = null, options = {}) {
    if (chat.id !== message.chatId) return chat;

    const currentLastId = chat.lastMessage?.id ?? 0;
    const shouldReplaceLast = !chat.lastMessage || message.id >= currentLastId || message.id === currentLastId;
    const isNewActivity = options.isNewActivity ?? message.id > currentLastId;

    if (!shouldReplaceLast) {
        return chat;
    }

    return {
        ...chat,
        lastMessage: message,
        updatedAt: isNewActivity ? message.createdAt : chat.updatedAt,
        preview: getMessagePreview(message),
        unreadCount:
            options.forceUnreadZero || (isNewActivity && myUserId !== null && message.authorUserId === myUserId)
                ? 0
                : chat.unreadCount,
    };
}

function mergeMessageIntoChats(chats, message, myUserId = null, options = {}) {
    return sortChatsByActivity(chats.map((chat) => mergeMessageIntoChat(chat, message, myUserId, options)));
}

function isNearBottom(node) {
    if (!node) return true;
    return node.scrollHeight - node.scrollTop - node.clientHeight < 96;
}

function ModalSheet({ open, title, children, onClose }) {
    if (!open) return null;

    return (
        <div className="chats-modal" onClick={onClose} role="presentation">
            <div
                className="chats-modal-sheet"
                onClick={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label={title}
            >
                <div className="chats-modal-handle" />
                <div className="chats-modal-top">
                    <div className="chats-modal-title">{title}</div>
                    <button type="button" className="icon-button" onClick={onClose} aria-label={UI_TEXT.close}>
                        <Icon name="close" />
                        <span className="visually-hidden">{UI_TEXT.close}</span>
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}

function Icon({ name }) {
    const icons = {
        back: (
            <path d="M15.5 4.5 8 12l7.5 7.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
        ),
        close: (
            <path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
        ),
        search: (
            <>
                <circle cx="10.5" cy="10.5" r="5.8" fill="none" stroke="currentColor" strokeWidth="1.8" />
                <path d="M15 15l4 4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
            </>
        ),
        media: (
            <>
                <rect x="4.5" y="5.5" width="15" height="13" rx="2.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
                <circle cx="9" cy="10" r="1.3" fill="currentColor" />
                <path d="m7 16 3.2-3.2a1 1 0 0 1 1.4 0L13 14l2.7-2.7a1 1 0 0 1 1.4 0L19 13" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
            </>
        ),
        settings: (
            <>
                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
                <path d="M12 3.8v2.1M12 18.1v2.1M20.2 12h-2.1M5.9 12H3.8M17.8 6.2l-1.5 1.5M7.7 16.3l-1.5 1.5M17.8 17.8l-1.5-1.5M7.7 7.7 6.2 6.2" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.6" />
            </>
        ),
        phone: (
            <path d="M7.2 4.8 9.7 4c.8-.3 1.7.1 2 .9l.9 2.2c.3.7.1 1.5-.5 2l-1.2.9a10.5 10.5 0 0 0 4.8 4.8l.9-1.2c.5-.6 1.3-.8 2-.5l2.2.9c.8.3 1.2 1.2.9 2l-.8 2.5c-.2.7-.9 1.2-1.7 1.2C10.9 19.7 4.3 13.1 4.3 6.8c0-.8.5-1.5 1.2-1.7Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
        ),
        phoneOff: (
            <>
                <path d="M6.5 17.5c3.4-3.1 7.6-3.1 11 0" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
                <path d="M7.8 15.7 6.5 14c-.5-.7-.4-1.6.2-2.1l1.3-1.1c.5-.4 1.2-.4 1.8-.1l1.3.8M15 11.5l1.3-.8c.6-.3 1.3-.3 1.8.1l1.3 1.1c.6.5.7 1.4.2 2.1l-1.3 1.7" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
            </>
        ),
        edit: (
            <>
                <path d="m6 16.5 1 3 3-1 8.8-8.8-3-3L7 15.5Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.6" />
                <path d="m14.8 7.7 3 3" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.6" />
            </>
        ),
        trash: (
            <>
                <path d="M5.5 7.5h13M9.2 4.8h5.6M9 10.5v6M15 10.5v6M7.8 7.5l.7 10.2a2 2 0 0 0 2 1.8h3a2 2 0 0 0 2-1.8l.7-10.2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
            </>
        ),
        reply: (
            <path d="M10 7 5 12l5 5M6 12h8.5a4.5 4.5 0 0 1 4.5 4.5V18" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
        ),
        copy: (
            <path d="M8 8.5V6.8A2.8 2.8 0 0 1 10.8 4h5.4A2.8 2.8 0 0 1 19 6.8v5.4a2.8 2.8 0 0 1-2.8 2.8H14.5M5 9.8A2.8 2.8 0 0 1 7.8 7h5.4A2.8 2.8 0 0 1 16 9.8v5.4a2.8 2.8 0 0 1-2.8 2.8H7.8A2.8 2.8 0 0 1 5 15.2Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
        ),
        forward: (
            <path d="m14 7 5 5-5 5M18 12H9.5A4.5 4.5 0 0 0 5 16.5V18" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
        ),
        pin: (
            <path d="m14.5 4.5 5 5-3 1.1-3.8 3.8.4 3.1-1.1 1.1-3.3-3.3L5.5 18 4 16.5l2.7-3.2-3.3-3.3 1.1-1.1 3.1.4 3.8-3.8 1.1-3Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        ),
        star: (
            <path d="m12 4.5 2.2 4.5 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L4.8 9.7l5-.7Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        ),
        addUser: (
            <>
                <path d="M12 13.5c-3.1 0-5.7 1.6-6.5 4" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.6" />
                <circle cx="12" cy="9" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
                <path d="M18 7.5v5M15.5 10h5" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
            </>
        ),
        attach: (
            <path d="M8.5 12.5 14.8 6.2a3 3 0 1 1 4.2 4.2l-8 8a4.5 4.5 0 0 1-6.4-6.4l8.1-8.1" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
        ),
        mic: (
            <>
                <rect x="9" y="4.5" width="6" height="10" rx="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
                <path d="M7 11.8a5 5 0 0 0 10 0M12 16.8v2.7M9 19.5h6" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
            </>
        ),
        micOff: (
            <>
                <path d="M5 5l14 14" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
                <path d="M9 7.2V7a3 3 0 0 1 5.5-1.7M15 10.8v1A3 3 0 0 1 10.2 14" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
                <path d="M7 11.8a5 5 0 0 0 8 4M17 11.8a5 5 0 0 1-.7 2.5M12 16.8v2.7M9 19.5h6" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
            </>
        ),
        stop: (
            <rect x="7" y="7" width="10" height="10" rx="2" fill="currentColor" />
        ),
        play: (
            <path d="M8 6.5v11l9-5.5-9-5.5Z" fill="currentColor" />
        ),
        pause: (
            <path d="M8 6.5h3v11H8zM13 6.5h3v11h-3z" fill="currentColor" />
        ),
        send: (
            <path d="M20 4 9 15M20 4l-7 16-2.8-6.2L4 11l16-7Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
        ),
        down: (
            <path d="M6.5 9.5 12 15l5.5-5.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
        ),
        plus: (
            <path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
        ),
    };

    return (
        <svg className="ui-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            {icons[name] || null}
        </svg>
    );
}

function formatFileSize(size) {
    if (!size) return '0 B';
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${Math.round(size / 102.4) / 10} KB`;
    return `${Math.round(size / 104857.6) / 10} MB`;
}

function formatDuration(seconds) {
    const value = Math.max(0, Number(seconds) || 0);
    const mins = Math.floor(value / 60);
    const secs = value % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
}

function getMessagePreview(message) {
    if (!message) return UI_TEXT.noMessages;
    if (message.isDeleted) return UI_TEXT.deletedMessage;
    if (message.type === 'voice') return UI_TEXT.voiceMessage;
    if (message.type === 'media') return message.text?.trim() || UI_TEXT.photoOrVideo;
    if (message.type === 'file') return message.text?.trim() || UI_TEXT.file;
    return message.text || UI_TEXT.noMessages;
}

function VoiceAttachment({ attachment, src }) {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [playError, setPlayError] = useState(false);
    const [durationSec, setDurationSec] = useState(Number(attachment.durationSec) || 0);

    const stopBubble = (event) => {
        event.stopPropagation();
    };

    const togglePlayback = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const audio = audioRef.current;
        if (!audio) return;

        setPlayError(false);

        if (!audio.paused) {
            audio.pause();
            return;
        }

        try {
            setIsLoading(true);
            if (audio.readyState < 2) {
                audio.load();
            }
            await audio.play();
        } catch {
            setPlayError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="attachment-card voice" onPointerDown={stopBubble} onTouchStart={stopBubble}>
            <button
                type="button"
                className={`voice-play-button ${isPlaying ? 'playing' : ''}`}
                onClick={togglePlayback}
                aria-label={isPlaying ? 'Pause voice message' : 'Play voice message'}
            >
                {isLoading ? <span className="voice-loading-dot" /> : <Icon name={isPlaying ? 'pause' : 'play'} />}
            </button>
            <div className="voice-content">
                <div className="attachment-file-meta">
                    <strong>{UI_TEXT.voice}</strong>
                    <span>{formatDuration(durationSec)}</span>
                </div>
                <div className="voice-wave" aria-hidden="true">
                    {Array.from({ length: 18 }).map((_, index) => (
                        <span key={index} style={{ height: `${8 + ((index * 7) % 18)}px` }} />
                    ))}
                </div>
                {playError && <span className="voice-error">{UI_TEXT.mediaError}</span>}
            </div>
            <audio
                ref={audioRef}
                src={src}
                preload="auto"
                onLoadedMetadata={(event) => {
                    const nextDuration = Math.round(event.currentTarget.duration || 0);
                    if (nextDuration > 0) setDurationSec(nextDuration);
                }}
                onPlaying={() => {
                    setIsLoading(false);
                    setIsPlaying(true);
                }}
                onPause={() => setIsPlaying(false)}
                onEnded={() => setIsPlaying(false)}
                onError={() => {
                    setIsLoading(false);
                    setIsPlaying(false);
                    setPlayError(true);
                }}
            />
        </div>
    );
}

function AttachmentPreview({ attachment, onOpenMedia }) {
    const src = chatApi.resolveAssetUrl(attachment.url);

    if (attachment.kind === 'image') {
        return (
            <button
                type="button"
                className="attachment-card media media-button"
                onClick={() => onOpenMedia?.({ kind: 'image', url: src, title: attachment.originalName || UI_TEXT.attachment })}
                aria-label={UI_TEXT.openMedia}
            >
                <img src={src} alt={attachment.originalName || UI_TEXT.attachment} className="attachment-image" />
            </button>
        );
    }

    if (attachment.kind === 'video') {
        return (
            <div className="attachment-card media">
                <video src={src} controls className="attachment-video" />
            </div>
        );
    }

    if (attachment.kind === 'voice') {
        return <VoiceAttachment attachment={attachment} src={src} />;
    }

    return (
        <a className="attachment-card file" href={src} target="_blank" rel="noreferrer">
            <div className="attachment-file-meta">
                <strong>{attachment.originalName || UI_TEXT.file}</strong>
                <span>{formatFileSize(attachment.size)}</span>
            </div>
        </a>
    );
}

function renderInlineText(text) {
    const nodes = [];
    const pattern = /(`[^`]+`|https?:\/\/[^\s<]+)/g;
    let lastIndex = 0;
    let match;

    while ((match = pattern.exec(text)) !== null) {
        if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
        const value = match[0];
        if (value.startsWith('`')) {
            nodes.push(<code key={`code-${match.index}`}>{value.slice(1, -1)}</code>);
        } else {
            nodes.push(<a key={`link-${match.index}`} href={value} target="_blank" rel="noreferrer">{value}</a>);
        }
        lastIndex = match.index + value.length;
    }

    if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
    return nodes;
}

function MessageText({ text }) {
    return (
        <div className="message-text">
            {(text || '').split(/(```[\s\S]*?```)/g).map((part, partIndex) => {
                if (part.startsWith('```') && part.endsWith('```')) {
                    return <pre key={partIndex}><code>{part.slice(3, -3).trim()}</code></pre>;
                }
                const lines = part.split('\n');
                return lines.map((line, lineIndex) => (
                    <React.Fragment key={`${partIndex}-${lineIndex}`}>
                        {renderInlineText(line)}
                        {lineIndex < lines.length - 1 && <br />}
                    </React.Fragment>
                ));
            })}
        </div>
    );
}

function LinkPreview({ url }) {
    if (!url) return null;
    let domain = '';
    try {
        domain = new URL(url).hostname.replace(/^www\./, '');
    } catch {
        return null;
    }

    return (
        <a className="link-preview-card" href={url} target="_blank" rel="noreferrer">
            <span className="link-preview-domain">{domain}</span>
            <span className="link-preview-url">{url}</span>
        </a>
    );
}

function MessageContent({ message, onOpenMedia }) {
    const attachments = Array.isArray(message.attachments) ? message.attachments : [];
    if (message.isDeleted) {
        return <div className="message-text deleted">{UI_TEXT.deletedMessage}</div>;
    }

    return (
        <>
            {attachments.length > 0 && (
                <div className="attachment-stack">
                    {attachments.map((attachment) => (
                        <AttachmentPreview key={attachment.id} attachment={attachment} onOpenMedia={onOpenMedia} />
                    ))}
                </div>
            )}
            {message.replyTo && (
                <div className="message-reply-preview">
                    <strong>Ответ</strong>
                    <span>{message.replyTo.isDeleted ? UI_TEXT.deletedMessage : (message.replyTo.text || UI_TEXT.attachment)}</span>
                </div>
            )}
            {message.forwardedFrom && (
                <div className="message-forwarded">
                    <Icon name="forward" />
                    <span>Переслано</span>
                </div>
            )}
            {message.text ? <MessageText text={message.text} /> : null}
            {Array.isArray(message.links) && message.links.length > 0 && (
                <div className="message-links">
                    <LinkPreview url={message.links[0]} />
                </div>
            )}
            {Array.isArray(message.reactions) && message.reactions.length > 0 && (
                <div className="message-reactions">
                    {message.reactions.map((reaction) => (
                        <span key={reaction.reaction} className={`message-reaction ${reaction.reactedByMe ? 'mine' : ''}`}>
                            {reaction.reaction} <strong>{reaction.count}</strong>
                        </span>
                    ))}
                </div>
            )}
        </>
    );
}

function CallScreenTrack({ entry }) {
    const video = useRef(null);
    useEffect(() => { const element = video.current; entry.track.attach(element); return () => { entry.track.detach(element); }; }, [entry.track]);
    return <figure className="chat-shared-screen"><figcaption>{entry.name}</figcaption><video ref={video} autoPlay playsInline muted controls /></figure>;
}

const ChatsPage = ({basePath = '/chats'}) => {
    const navigate = useNavigate();
    const { chatId: routeChatIdParam } = useParams();
    const routeChatId = useMemo(() => parseRouteChatId(routeChatIdParam), [routeChatIdParam]);
    const [isMobile, setIsMobile] = useState(getIsMobileViewport);
    const [mobileView, setMobileView] = useState('list');

    const [loadingChats, setLoadingChats] = useState(true);
    const [chatsError, setChatsError] = useState(null);
    const [selectedChatAccessError, setSelectedChatAccessError] = useState(null);
    const [chats, setChats] = useState([]);
  const chatsRef = useRef(chats);
  chatsRef.current = chats;
    const [selectedChatId, setSelectedChatId] = useState(null);
  const [messengerChatVisible, setMessengerChatVisible] = useState(true);
  const [moreChatsLoading, setMoreChatsLoading] = useState(false);
  const [hasMoreChats, setHasMoreChats] = useState(true);

    const [messages, setMessages] = useState([]);
    const [messagesLoading, setMessagesLoading] = useState(false);
    const [messagesReadyChatId, setMessagesReadyChatId] = useState(null);
    const [messagesError, setMessagesError] = useState(null);
    const [hasMore, setHasMore] = useState(false);

    const [readStates, setReadStates] = useState({});
    const [typingStates, setTypingStates] = useState([]);

    const [query, setQuery] = useState('');
    const [listFilter, setListFilter] = useState('all');
    const [messageDraft, setMessageDraft] = useState('');

    const [createPhone, setCreatePhone] = useState('');
    const [createTitle, setCreateTitle] = useState('');
    const [createBusy, setCreateBusy] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);

    const [invitePhone, setInvitePhone] = useState('');
    const [inviteBusy, setInviteBusy] = useState(false);
    const [isInviteOpen, setIsInviteOpen] = useState(false);

    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [settingsLoading, setSettingsLoading] = useState(false);
    const [settingsBusy, setSettingsBusy] = useState(false);
    const [chatSettings, setChatSettings] = useState(null);
    const [settingsDraft, setSettingsDraft] = useState(null);

    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchBusy, setSearchBusy] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
  const [searchCursor, setSearchCursor] = useState(null);
  const searchRequestRef = useRef(0);
  useEffect(() => { searchRequestRef.current++; setSearchCursor(null); setSearchResults([]); setSearchBusy(false); }, [searchQuery, selectedChatId]);

    const [isMediaOpen, setIsMediaOpen] = useState(false);
    const [mediaBucket, setMediaBucket] = useState('media');
    const [mediaLoading, setMediaLoading] = useState(false);
    const [mediaItems, setMediaItems] = useState([]);

    const [uploadBusy, setUploadBusy] = useState(false);
    const [pendingFiles, setPendingFiles] = useState([]);
    const [isAttachmentSheetOpen, setIsAttachmentSheetOpen] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [focusedMessageId, setFocusedMessageId] = useState(null);
    const [editingMessageId, setEditingMessageId] = useState(null);
    const [replyingToMessageId, setReplyingToMessageId] = useState(null);
    const [activeMessageAction, setActiveMessageAction] = useState(null);
    const [pinnedMessages, setPinnedMessages] = useState([]);
    const [forwardingMessageId, setForwardingMessageId] = useState(null);
    const [isForwardOpen, setIsForwardOpen] = useState(false);
    const [isEmojiOpen, setIsEmojiOpen] = useState(false);
    const [isDragOver, setIsDragOver] = useState(false);
    const [activeMediaPreview, setActiveMediaPreview] = useState(null);
    const [activeCalls, setActiveCalls] = useState([]);
    const [currentCallId, setCurrentCallId] = useState(null);
    const [currentCallSnapshot, setCurrentCallSnapshot] = useState(null);
    const [callPhase, setCallPhase] = useState('idle');
    const [callBusy, setCallBusy] = useState(false);
    const [callMuted, setCallMuted] = useState(false);
    const [screenSharing, setScreenSharing] = useState(false);
    const [screenTracks, setScreenTracks] = useState([]);
    const [callError, setCallError] = useState('');
    const [callSoundBlocked, setCallSoundBlocked] = useState(false);
    const [callConnectedAt, setCallConnectedAt] = useState(null);
    const [callElapsedSec, setCallElapsedSec] = useState(0);
    const [toastMessage, setToastMessage] = useState('');

    const [showJumpButton, setShowJumpButton] = useState(false);

    const streamRef = useRef(null);
    const lastStreamMessageIdRef = useRef(0);
    const reconnectTimerRef = useRef(null);
    const typingIdleTimerRef = useRef(null);
    const typingSentRef = useRef(false);
    const lastReadSentRef = useRef(0);
    const selectedChatIdRef = useRef(null);
    selectedChatIdRef.current = selectedChatId;
    const prependScrollRef = useRef(null);
    const shouldStickToBottomRef = useRef(true);
    const pendingScrollToBottomRef = useRef(false);
    const messagesPanelRef = useRef(null);
    const composerTextareaRef = useRef(null);
    const pageRef = useRef(null);
    const attachmentInputRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const mediaChunksRef = useRef([]);
    const recordingStreamRef = useRef(null);
    const recordingStartedAtRef = useRef(0);
    const longPressTimerRef = useRef(null);
    const callConnectionRef = useRef(null);
    const callToneRef = useRef(null);

    const selectedChat = useMemo(
        () => chats.find((chat) => chat.id === selectedChatId) ?? null,
        [chats, selectedChatId]
    );

    const selectedChatAvatar = useMemo(() => buildAvatar(selectedChat), [selectedChat]);
    const editingMessage = useMemo(
        () => messages.find((message) => message.id === editingMessageId) ?? null,
        [editingMessageId, messages]
    );
    const replyingToMessage = useMemo(
        () => messages.find((message) => message.id === replyingToMessageId) ?? null,
        [replyingToMessageId, messages]
    );
    const latestPinnedMessage = pinnedMessages[0] || null;

    const myUserId = useMemo(() => {
        if (!selectedChat) return null;
        const me = selectedChat.participants.find((participant) => participant.isMe);
        return me?.userId ?? null;
    }, [selectedChat]);

    const participantsByUserId = useMemo(() => {
        const map = new Map();
        (selectedChat?.participants || []).forEach((participant) => {
            if (participant.userId !== null) map.set(participant.userId, participant);
        });
        return map;
    }, [selectedChat]);

    const currentCall = useMemo(() => {
        if (!currentCallId) return null;
        return activeCalls.find((call) => String(call.id) === String(currentCallId)) || currentCallSnapshot;
    }, [activeCalls, currentCallId, currentCallSnapshot]);

    const incomingCall = useMemo(() => {
        if (!LEGACY_CALL_CONTROLS || currentCallId || myUserId == null) return null;
        return activeCalls.find((call) => isIncomingRingingCall(call, myUserId)) || null;
    }, [activeCalls, currentCallId, myUserId]);
    const incomingCallId = incomingCall?.id ?? null;

    const currentCallPeerLabel = useMemo(
        () => getCallPeerLabel(currentCall || incomingCall, selectedChat, myUserId),
        [currentCall, incomingCall, myUserId, selectedChat]
    );

    const currentCallRemoteConnected = useMemo(
        () => hasRemoteConnected(currentCall, myUserId),
        [currentCall, myUserId]
    );

    const callStatusLabel = useMemo(() => {
        if (callError) return callError;
        if (!currentCall) return '';
        if (currentCallRemoteConnected) return `${UI_TEXT.callInProgress} · ${formatDuration(callElapsedSec)}`;
        if (callPhase === 'connecting') return UI_TEXT.callConnecting;
        if (currentCall.initiatorUserId === myUserId) return UI_TEXT.callRinging;
        return UI_TEXT.callConnecting;
    }, [callElapsedSec, callError, callPhase, currentCall, currentCallRemoteConnected, myUserId]);

    const typingUserIds = useMemo(() => {
        const ids = typingStates
            .filter((state) => state.isTyping && state.userId !== null)
            .map((state) => state.userId);
        return Array.from(new Set(ids));
    }, [typingStates]);

    const filteredChats = useMemo(() => {
        const normalizedQuery = query.trim().toLowerCase();
        return chats.filter((chat) => {
            if (listFilter === 'unread' && !chat.unreadCount) return false;
            if (listFilter === 'important' && !chat.isImportant) return false;
            if (!normalizedQuery) return true;
            const name = buildChatName(chat).toLowerCase();
            const phones = (chat.participants || []).map((participant) => participant.phone ?? '').join(' ').toLowerCase();
            return name.includes(normalizedQuery) || phones.includes(normalizedQuery);
        });
    }, [chats, listFilter, query]);

    const selectedOtherParticipants = useMemo(
        () => selectedChat?.participants.filter((participant) => !participant.isMe) ?? [],
        [selectedChat]
    );

    const typingLabel = useMemo(() => {
        if (!typingUserIds.length) return '';

        const labels = selectedOtherParticipants
            .filter((participant) => participant.userId !== null && typingUserIds.includes(participant.userId))
            .map(buildParticipantLabel)
            .slice(0, 2);

        if (!labels.length) return 'Печатает...';
        if (labels.length === 1) return `${labels[0]} печатает...`;
        return `${labels[0]} и ${labels[1]} печатают...`;
    }, [selectedOtherParticipants, typingUserIds]);

    const messageItems = useMemo(() => {
        return messages.map((message, index) => {
            const previous = messages[index - 1] ?? null;
            const next = messages[index + 1] ?? null;
            const mine = myUserId !== null && myUserId === message.authorUserId;
            const dayKey = getDayKey(message.createdAt);
            const previousDayKey = previous ? getDayKey(previous.createdAt) : null;
            const nextDayKey = next ? getDayKey(next.createdAt) : null;
            const startsGroup = !previous || previous.authorUserId !== message.authorUserId || previousDayKey !== dayKey;
            const endsGroup = !next || next.authorUserId !== message.authorUserId || nextDayKey !== dayKey;
            const author = participantsByUserId.get(message.authorUserId);

            return {
                ...message,
                mine,
                isDeleted: Boolean(message.isDeleted),
                startsGroup,
                endsGroup,
                isFocused: focusedMessageId === message.id,
                showDateDivider: !previous || previousDayKey !== dayKey,
                dateLabel: formatDateLabel(message.createdAt),
                authorLabel: buildParticipantLabel(author),
                showAuthor: Boolean(selectedChat?.isGroup && !mine && startsGroup),
                canEdit: Boolean(mine && !message.isDeleted && message.type === 'text'),
                canDelete: Boolean(mine && !message.isDeleted && message.type !== 'system'),
            };
        });
    }, [focusedMessageId, messages, myUserId, participantsByUserId, selectedChat?.isGroup]);

    const syncJumpButton = useCallback(() => {
        const panel = messagesPanelRef.current;
        const nearBottom = isNearBottom(panel);
        shouldStickToBottomRef.current = nearBottom;
        setShowJumpButton(!nearBottom && messages.length > 0);
    }, [messages.length]);

    const scrollToBottom = useCallback((behavior = 'smooth') => {
        const panel = messagesPanelRef.current;
        if (!panel) return;

        panel.scrollTo({ top: panel.scrollHeight, behavior });
        shouldStickToBottomRef.current = true;
        setShowJumpButton(false);
    }, []);

    const showToast = useCallback((message) => {
        setToastMessage(message);
        window.setTimeout(() => setToastMessage(''), 2200);
    }, []);

    const stopCallTone = useCallback(() => {
        callToneRef.current?.stop();
        callToneRef.current = null;
        setCallSoundBlocked(false);
    }, []);

    const startCallTone = useCallback(async (kind) => {
        stopCallTone();
        const tone = createCallTone(kind);
        callToneRef.current = tone;
        const started = await tone.start();
        setCallSoundBlocked(!started);
    }, [stopCallTone]);

    const disconnectCurrentCall = useCallback(async () => {
        const connection = callConnectionRef.current;
        callConnectionRef.current = null;
        if (!connection) return;
        await connection.disconnect().catch(() => undefined);
    }, []);

    const recordCallEvent = useCallback((callId, payload) => {
        if (!callId) return;
        void chatApi.recordCallQualityEvent(callId, payload).catch(() => undefined);
    }, []);

    const rememberCall = useCallback((call) => {
        if (!call?.id) return;
        setCurrentCallSnapshot(call);
        setActiveCalls((previous) => upsertCalls(previous, call));
    }, []);

    const joinAndConnectCall = useCallback(async (call, phase) => {
        if (!call?.id) {
            setCallPhase('failed');
            setCallError(UI_TEXT.callFailed);
            setCallBusy(false);
            return;
        }
        const callId = call.id;

        setCurrentCallId(String(callId));
        setCurrentCallSnapshot(call);
        setCallPhase('connecting');
        setCallError('');
        setCallBusy(true);
        setCallMuted(false);

        try {
            await disconnectCurrentCall();
            const response = await chatApi.joinCall(callId);
            if (!response?.livekitUrl || !response?.livekitToken) {
                throw new Error(UI_TEXT.callFailed);
            }
            if (response.call) rememberCall(response.call);

            const connection = await connectLiveKitAudioCall({
                livekitUrl: response.livekitUrl,
                livekitToken: response.livekitToken,
                onScreenTracks: setScreenTracks,
                onScreenSharingChanged: setScreenSharing,
                onConnected: () => recordCallEvent(callId, { eventType: 'connected', phase }),
                onDisconnected: (reason) => recordCallEvent(callId, { eventType: 'disconnected', phase, reason: String(reason || '') }),
                onParticipantConnected: () => recordCallEvent(callId, { eventType: 'remote_connected', phase }),
                onParticipantDisconnected: () => recordCallEvent(callId, { eventType: 'remote_disconnected', phase }),
                onError: (error) => recordCallEvent(callId, { eventType: 'media_error', phase, reason: String(error?.message || error || '') }),
            });

            callConnectionRef.current = connection;
            setCallPhase('connected');
        } catch (error) {
            await chatApi.leaveCall(callId).catch(() => undefined);
            await disconnectCurrentCall();
            stopCallTone();
            setCallPhase('failed');
            setCallError(formatCallError(error));
            recordCallEvent(callId, { eventType: 'connect_failed', phase, reason: String(error?.message || error || '') });
        } finally {
            setCallBusy(false);
        }
    }, [disconnectCurrentCall, recordCallEvent, rememberCall, stopCallTone]);

    const startAudioCall = useCallback(async () => {
        if (!selectedChatId || currentCallId || callBusy || selectedChat?.canStartCall === false || selectedChat?.isChannel) return;

        setCallBusy(true);
        setCallPhase('outgoing');
        setCallError('');
        setCallMuted(false);
        setCallConnectedAt(null);
        setCallElapsedSec(0);
        await startCallTone('ringback');

        try {
            const call = await chatApi.startCall(selectedChatId, 'audio', { protocol: CALL_PROTOCOL_LIVEKIT });
            if (!call?.id) throw new Error(UI_TEXT.callFailed);
            rememberCall(call);
            await joinAndConnectCall(call, 'outgoing');
        } catch (error) {
            stopCallTone();
            setCallPhase('failed');
            setCallError(formatCallError(error));
            setCallBusy(false);
        }
    }, [callBusy, currentCallId, joinAndConnectCall, rememberCall, selectedChatId, selectedChat, startCallTone, stopCallTone]);

    const answerIncomingCall = useCallback(async () => {
        if (!incomingCall || callBusy) return;
        stopCallTone();
        await joinAndConnectCall(incomingCall, 'incoming');
    }, [callBusy, incomingCall, joinAndConnectCall, stopCallTone]);

    const declineIncomingCall = useCallback(async () => {
        if (!incomingCall || callBusy) return;
        setCallBusy(true);
        try {
            const updated = await chatApi.declineCall(incomingCall.id);
            if (updated) rememberCall(updated);
            setActiveCalls((previous) => previous.filter((call) => String(call.id) !== String(incomingCall.id)));
            stopCallTone();
        } catch (error) {
            showToast(formatCallError(error));
        } finally {
            setCallBusy(false);
        }
    }, [callBusy, incomingCall, rememberCall, showToast, stopCallTone]);

    const endCurrentCall = useCallback(async () => {
        if (!currentCall || callBusy) return;
        const callId = currentCall.id;
        const shouldLeaveOnly = (currentCall.participants || []).length > 2 && currentCall.initiatorUserId !== myUserId;

        setCallBusy(true);
        setCallPhase('ending');
        stopCallTone();
        await disconnectCurrentCall();

        try {
            const updated = shouldLeaveOnly ? await chatApi.leaveCall(callId) : await chatApi.endCall(callId);
            if (updated) rememberCall(updated);
            setActiveCalls((previous) => previous.filter((call) => String(call.id) !== String(callId)));
            setCurrentCallId(null);
            setCurrentCallSnapshot(null);
            setCallPhase('idle');
            setCallMuted(false);
            setCallError('');
            setCallConnectedAt(null);
            setCallElapsedSec(0);
        } catch (error) {
            setCallPhase('failed');
            setCallError(formatCallError(error));
        } finally {
            setCallBusy(false);
        }
    }, [callBusy, currentCall, disconnectCurrentCall, myUserId, rememberCall, stopCallTone]);

    const toggleScreenSharing = async () => {
        const connection = callConnectionRef.current;
        if (!connection || callBusy) return;
        setCallBusy(true); setCallError('');
        try { await connection.setScreenSharing(!screenSharing); }
        catch (error) { if (error?.name !== 'NotAllowedError') setCallError(error?.message === 'screen_share_not_supported' ? 'Этот браузер не поддерживает демонстрацию экрана.' : 'Не удалось включить демонстрацию экрана.'); }
        finally { setCallBusy(false); }
    };

    const toggleCallMute = useCallback(async () => {
        const connection = callConnectionRef.current;
        if (!connection || callBusy) return;
        const nextMuted = !callMuted;
        setCallBusy(true);
        try {
            await connection.setMuted(nextMuted);
            setCallMuted(nextMuted);
            recordCallEvent(currentCallId, { eventType: nextMuted ? 'muted' : 'unmuted', phase: callPhase });
        } catch (error) {
            setCallError(formatCallError(error));
        } finally {
            setCallBusy(false);
        }
    }, [callBusy, callMuted, callPhase, currentCallId, recordCallEvent]);

    const enableCallSound = useCallback(async () => {
        if (incomingCall && !currentCallId) {
            await startCallTone('incoming');
            return;
        }
        if (currentCall && !currentCallRemoteConnected) {
            await startCallTone('ringback');
        }
    }, [currentCall, currentCallId, currentCallRemoteConnected, incomingCall, startCallTone]);

    const openChat = useCallback(
        (chatId) => {
            setSelectedChatId(chatId);
            setSelectedChatAccessError(null);
            pendingScrollToBottomRef.current = true;
            if (isMobile) setMobileView('chat');
            if (chatId && window.location.pathname !== `${basePath}/${chatId}`) {
                navigate(`${basePath}/${chatId}`);
            }
        },
        [isMobile, navigate, basePath]
    );

    const loadChats = useCallback(async () => {
        setLoadingChats(true);
        setChatsError(null);
        setSelectedChatAccessError(null);

        try {
            let list = sortChatsByActivity(await chatApi.listChats());
            if (routeChatId && !list.some((chat) => chat.id === routeChatId)) {
                try {
                    const routeChat = await chatApi.getChat(routeChatId);
                    list = sortChatsByActivity([routeChat, ...list.filter((chat) => chat.id !== routeChat.id)]);
                } catch (error) {
                    setSelectedChatAccessError(formatChatError(error, 'Нет доступа к этому чату'));
                }
            }
            setChats(list);
            if (routeChatId && getIsMobileViewport()) {
                setMobileView('chat');
            }
            setSelectedChatId((previousChatId) => {
                if (routeChatId) {
                    return list.some((chat) => chat.id === routeChatId) ? routeChatId : null;
                }
                if (previousChatId && list.some((chat) => chat.id === previousChatId)) return previousChatId;
                return list[0]?.id ?? null;
            });
        } catch (error) {
            setChatsError(formatChatError(error, 'Не удалось загрузить чаты'));
        } finally {
            setLoadingChats(false);
        }
    }, [routeChatId]);

    const loadMessages = useCallback(async (chatId, beforeId) => {
        if (!chatId) return;

        if (beforeId) {
            const panel = messagesPanelRef.current;
            if (panel) {
                prependScrollRef.current = {
                    previousHeight: panel.scrollHeight,
                    previousTop: panel.scrollTop,
                };
            }
        } else {
            setMessagesLoading(true);
            setMessagesReadyChatId(null);
            setMessagesError(null);
            setMessages([]);
            setReadStates({});
            setTypingStates([]);
            lastReadSentRef.current = 0;
            shouldStickToBottomRef.current = true;
            setShowJumpButton(false);
            pendingScrollToBottomRef.current = true;
            setPinnedMessages([]);
        }

        try {
            const data = await chatApi.listMessages(chatId, { limit: 30, beforeId });
            if (selectedChatIdRef.current !== chatId) return;

            if (beforeId) setMessages((previous) => upsertMessages(previous, data.items));
            else {
                setMessages(data.items);
                lastStreamMessageIdRef.current = data.items.length ? data.items[data.items.length - 1].id : 0;
                setMessagesReadyChatId(chatId);
                void chatApi.listPins(chatId).then(setPinnedMessages).catch(() => {});
            }

            setHasMore(Boolean(data.hasMore));
        } catch (error) {
            setMessagesError(error?.details?.error || error?.message || 'Не удалось загрузить сообщения');
        } finally {
            if (!beforeId) setMessagesLoading(false);
        }
    }, []);

    const applyStreamState = useCallback((payload) => {
        if (payload.cursor?.lastMessageId) {
            lastStreamMessageIdRef.current = payload.cursor.lastMessageId;
        }
        if (payload.messages?.length) {
            setMessages((previous) => upsertMessages(previous, payload.messages));
            setChats((previous) =>
                payload.messages.reduce(
                    (currentChats, message) =>
                        mergeMessageIntoChats(currentChats, message, myUserId, {
                            isNewActivity: message.id > (currentChats.find((chat) => chat.id === message.chatId)?.lastMessage?.id ?? 0),
                        }),
                    previous
                )
            );
        }

        if (Array.isArray(payload.reads)) {
            setReadStates(() => {
                const next = {};
                payload.reads.forEach((state) => {
                    if (state.userId !== null) next[state.userId] = state;
                });
                return next;
            });
        }

        if (Array.isArray(payload.typing)) {
            setTypingStates(payload.typing);
        }
        if (Array.isArray(payload.pinnedMessages)) {
            setPinnedMessages(payload.pinnedMessages);
        }
        if (Array.isArray(payload.activeCalls)) {
            setActiveCalls(payload.activeCalls.filter(isActiveCall));
        }
    }, [myUserId]);

    const connectStream = useCallback((chatId) => {
        if (streamRef.current) streamRef.current.close();
        const close = messengerClient.subscribe({ chatId, onState: payload => {
            if (selectedChatIdRef.current !== chatId) return;
            setMessages(previous => mergeWindow(previous, payload));
            applyStreamState({ ...payload, messages: [] });
        } });
        streamRef.current = { close };
    }, [applyStreamState]);

    const stopTyping = useCallback(async () => {
        if (!selectedChatId || !typingSentRef.current) return;

        typingSentRef.current = false;

        try {
            await chatApi.setTyping(selectedChatId, false);
        } catch {
            // typing failures should not block the composer
        }
    }, [selectedChatId]);

    const sendTyping = useCallback(async () => {
        if (!selectedChatId) return;

        if (!typingSentRef.current) {
            typingSentRef.current = true;
            try {
                await chatApi.setTyping(selectedChatId, true);
            } catch {
                // typing failures should not block the composer
            }
        }

        if (typingIdleTimerRef.current) {
            window.clearTimeout(typingIdleTimerRef.current);
        }

        typingIdleTimerRef.current = window.setTimeout(() => {
            void stopTyping();
        }, 1500);
    }, [selectedChatId, stopTyping]);

  useEffect(() => {
    let live = true;
    const unsubscribe = messengerClient.subscribe({ onInvalidate: (ids) => {
      const refresh = async () => {
        try {
          if (ids && ids.length > 0 && ids.length <= 4) {
            const rows = await Promise.all(ids.map(async (id) => {
              try { return await messengerClient.request('/api/chats/' + id + '?compactParticipants=1'); }
              catch (error) { return error.response && [403, 404].includes(error.response.status) ? { id: Number(id), removed: true } : null; }
            }));
            if (live) setChats(previous => { const map = new Map(previous.map(item => [item.id, item])); rows.forEach(item => { if (item) { if (item.removed) map.delete(item.id); else map.set(item.id, item); } }); return sortChatsByActivity(Array.from(map.values())); });
          } else {
            const [data, revoked] = await Promise.all([messengerClient.request('/api/chats?limit=40&compactParticipants=1'), messengerClient.findRevokedThreadIds(chatsRef.current.map(item => item.id))]);
            if (live) setChats(previous => sortChatsByActivity(Array.from(new Map(previous.filter(item => !revoked.has(String(item.id))).concat(data.items || []).map(item => [item.id, item])).values())));
          }
        } catch { /* Existing list remains available during reconnect. */ }
      };
      void refresh();
    } });
    return () => { live = false; unsubscribe(); };
  }, []);
  const loadMoreChats = async () => {
    if (moreChatsLoading) return;
    setMoreChatsLoading(true);
    try {
      const items = await chatApi.listChats(40, chats.length);
      setHasMoreChats(items.length === 40);
      setChats(previous => sortChatsByActivity(Array.from(new Map(previous.concat(items).map(item => [item.id, item])).values())));
    } catch { setChatsError('Не удалось загрузить чаты. Повторите попытку.'); }
    finally { setMoreChatsLoading(false); }
  };

    const markLatestRead = useCallback(async () => {
    if (!messengerChatVisible || document.visibilityState === 'hidden') return;
        if (!selectedChatId || !myUserId || !messages.length) return;

        const lastMessage = messages[messages.length - 1];
        if (!lastMessage || lastMessage.authorUserId === myUserId) return;
    const element = document.getElementById(`chat-message-${lastMessage.id}`);
    if (!element) return;
    const bounds = element.getBoundingClientRect();
    const viewport = element.parentElement && element.parentElement.getBoundingClientRect();
    if (bounds.height <= 0 || !viewport || bounds.bottom > Math.min(viewport.bottom, window.innerHeight) + 2 || bounds.bottom < viewport.top + 10) return;
        if (lastMessage.id <= lastReadSentRef.current) return;

        lastReadSentRef.current = lastMessage.id;

        try {
            const state = await chatApi.markRead(selectedChatId, lastMessage.id);
            if (state.userId !== null) {
                setReadStates((previous) => ({ ...previous, [state.userId]: state }));
            }

            setChats((previous) =>
                previous.map((chat) => (chat.id === selectedChatId ? { ...chat, unreadCount: 0 } : chat))
            );
        } catch {
            // read sync failure should not block the UI
        }
    }, [messages, myUserId, selectedChatId, messengerChatVisible]);

    const cancelEditingMessage = useCallback(() => {
        setEditingMessageId(null);
        setReplyingToMessageId(null);
        setMessageDraft('');
    }, []);

    const startEditingMessage = useCallback((message) => {
        if (!message?.canEdit) return;

        setEditingMessageId(message.id);
        setReplyingToMessageId(null);
        setActiveMessageAction(null);
        setMessageDraft(message.text || '');
        window.setTimeout(() => {
            composerTextareaRef.current?.focus();
        }, 30);
    }, []);

    const applyMessageMutation = useCallback(
        (message, options = {}) => {
            if (!message) return;

            setMessages((previous) => upsertMessages(previous, [message]));
            setChats((previous) => mergeMessageIntoChats(previous, message, myUserId, options));
        },
        [myUserId]
    );

    const handleDeleteMessage = useCallback(
        async (message) => {
            if (!selectedChatId || !message?.canDelete) return;
            if (!window.confirm(UI_TEXT.deleteMessageConfirm)) return;

            try {
                const deletedMessage = await chatApi.deleteMessage(selectedChatId, message.id);
                applyMessageMutation(deletedMessage, { isNewActivity: false });
                setActiveMessageAction(null);
                if (editingMessageId === message.id) {
                    cancelEditingMessage();
                }
            } catch (error) {
                alert(error?.details?.error || error?.message || UI_TEXT.deleteMessageError);
            }
        },
        [applyMessageMutation, cancelEditingMessage, editingMessageId, selectedChatId]
    );

    const startReplyMessage = useCallback((message) => {
        if (!message || message.isDeleted) return;
        setReplyingToMessageId(message.id);
        setEditingMessageId(null);
        setActiveMessageAction(null);
        window.setTimeout(() => composerTextareaRef.current?.focus(), 30);
    }, []);

    const copyMessage = useCallback(async (message) => {
        try {
            if (navigator.clipboard && message?.text) await navigator.clipboard.writeText(message.text);
            showToast('Сообщение скопировано');
        } catch {
            alert('Не удалось скопировать сообщение');
        } finally {
            setActiveMessageAction(null);
        }
    }, [showToast]);

    const reactToMessage = useCallback(async (message, reaction) => {
        if (!selectedChatId || !message) return;
        try {
            const mine = (message.reactions || []).find((item) => item.reactedByMe);
            const updated = mine?.reaction === reaction
                ? await chatApi.deleteReaction(selectedChatId, message.id)
                : await chatApi.reactToMessage(selectedChatId, message.id, reaction);
            applyMessageMutation(updated, { isNewActivity: false, forceUnreadZero: true });
        } catch (error) {
            alert(error?.details?.error || error?.message || 'Не удалось выполнить действие');
        } finally {
            setActiveMessageAction(null);
        }
    }, [applyMessageMutation, selectedChatId]);

    const toggleMessagePin = useCallback(async (message) => {
        if (!selectedChatId || !message) return;
        try {
            const items = message.isPinned
                ? await chatApi.unpinMessage(selectedChatId, message.id)
                : await chatApi.pinMessage(selectedChatId, message.id);
            setPinnedMessages(items);
            setMessages((previous) => previous.map((item) => item.id === message.id ? { ...item, isPinned: !message.isPinned } : item));
        } catch (error) {
            alert(error?.details?.error || error?.message || 'Не удалось обновить закреп');
        } finally {
            setActiveMessageAction(null);
        }
    }, [selectedChatId]);

    const toggleMessageImportant = useCallback(async (message) => {
        if (!selectedChatId || !message) return;
        try {
            const updated = message.isImportantForMe
                ? await chatApi.unmarkMessageImportant(selectedChatId, message.id)
                : await chatApi.markMessageImportant(selectedChatId, message.id);
            applyMessageMutation(updated, { isNewActivity: false, forceUnreadZero: true });
        } catch (error) {
            alert(error?.details?.error || error?.message || 'Не удалось выполнить действие');
        } finally {
            setActiveMessageAction(null);
        }
    }, [applyMessageMutation, selectedChatId]);

    const openForwardMessage = useCallback((message) => {
        setForwardingMessageId(message.id);
        setIsForwardOpen(true);
        setActiveMessageAction(null);
    }, []);

    const forwardMessageToChat = useCallback(async (chat) => {
        if (!forwardingMessageId) return;
        try {
            const message = await chatApi.forwardMessage(chat.id, forwardingMessageId);
            setChats((previous) => mergeMessageIntoChats(previous, message, myUserId, { isNewActivity: true, forceUnreadZero: chat.id === selectedChatId }));
            if (chat.id === selectedChatId) setMessages((previous) => upsertMessages(previous, [message]));
            setIsForwardOpen(false);
            setForwardingMessageId(null);
            showToast('Сообщение переслано');
        } catch (error) {
            alert(error?.details?.error || error?.message || 'Не удалось переслать сообщение');
        }
    }, [forwardingMessageId, myUserId, selectedChatId, showToast]);

    const clearLongPress = useCallback(() => {
        if (longPressTimerRef.current) {
            window.clearTimeout(longPressTimerRef.current);
            longPressTimerRef.current = null;
        }
    }, []);

    const queueMessageActionSheet = useCallback(
        (message) => {
            if (!isMobile || !message || message.isDeleted) return;
            clearLongPress();
            longPressTimerRef.current = window.setTimeout(() => {
                setActiveMessageAction(message);
                if (navigator.vibrate) navigator.vibrate(10);
            }, 420);
        },
        [clearLongPress, isMobile]
    );

    const onCreateChat = useCallback(async () => {
        const phone = createPhone.trim();
        if (!phone) return;

        setCreateBusy(true);

        try {
            const created = await chatApi.createChat({
                title: createTitle.trim() || undefined,
                isGroup: false,
                participantPhones: [phone],
            });

            setChats((previous) => sortChatsByActivity([created, ...previous.filter((chat) => chat.id !== created.id)]));
            setCreatePhone('');
            setCreateTitle('');
            setIsCreateOpen(false);
            openChat(created.id);
        } catch (error) {
            alert(error?.details?.error || error?.message || 'Не удалось создать чат');
        } finally {
            setCreateBusy(false);
        }
    }, [createPhone, createTitle, openChat]);

    const onInvite = useCallback(async () => {
        if (!selectedChatId || !invitePhone.trim()) return;

        setInviteBusy(true);

        try {
            await chatApi.inviteByPhone(selectedChatId, invitePhone.trim());
            const updated = await chatApi.getChat(selectedChatId);
            setChats((previous) =>
                previous.map((chat) => (chat.id === selectedChatId ? { ...updated, unreadCount: chat.unreadCount } : chat))
            );
            setInvitePhone('');
            setIsInviteOpen(false);
        } catch (error) {
            alert(error?.details?.error || error?.message || 'Не удалось пригласить пользователя');
        } finally {
            setInviteBusy(false);
        }
    }, [invitePhone, selectedChatId]);

    const loadSettings = useCallback(async () => {
        if (!selectedChatId) return;

        setSettingsLoading(true);
        try {
            const settings = await chatApi.getChatSettings(selectedChatId);
            setChatSettings(settings);
            setSettingsDraft(settings?.preferences || null);
        } catch (error) {
            alert(error?.details?.error || error?.message || UI_TEXT.loadSettingsError);
        } finally {
            setSettingsLoading(false);
        }
    }, [selectedChatId]);

    const openSettings = useCallback(async () => {
        setIsSettingsOpen(true);
        await loadSettings();
    }, [loadSettings]);

    const saveSettings = useCallback(async () => {
        if (!selectedChatId || !settingsDraft) return;

        setSettingsBusy(true);
        try {
            const payload = { ...settingsDraft, title: chatSettings?.title };
            const response = await chatApi.updateChatSettings(selectedChatId, payload);
            setChatSettings(response.settings);
            setSettingsDraft(response.settings?.preferences || null);
            if (response.chat) {
                setChats((previous) =>
                    sortChatsByActivity(previous.map((chat) => (chat.id === selectedChatId ? { ...chat, ...response.chat } : chat)))
                );
            }
            setIsSettingsOpen(false);
        } catch (error) {
            alert(error?.details?.error || error?.message || UI_TEXT.saveSettingsError);
        } finally {
            setSettingsBusy(false);
        }
    }, [chatSettings?.title, selectedChatId, settingsDraft]);

  const searchInsideChat = useCallback(async (more = false) => {
    if (!selectedChatId || searchBusy) return;
    const chatId = selectedChatId;
    const current = ++searchRequestRef.current;
    setSearchBusy(true);
    try {
      const data = await messengerClient.request('/api/chats/' + chatId + '/messages/search?q=' + encodeURIComponent(searchQuery.trim()) + '&limit=40' + (more && searchCursor ? '&beforeId=' + searchCursor : ''));
      if (current !== searchRequestRef.current || selectedChatIdRef.current !== chatId) return;
      setSearchResults(previous => more ? previous.concat(data.items || []) : (data.items || []));
      setSearchCursor(data.nextCursor || null);
    } catch { if (current === searchRequestRef.current) showToast('Не удалось выполнить поиск. Повторите попытку.'); }
    finally { if (current === searchRequestRef.current) setSearchBusy(false); }
  }, [searchQuery, selectedChatId, searchBusy, searchCursor, showToast]);

    const jumpToMessage = useCallback(async (messageId) => {
        if (!selectedChatId || !messageId) return;

        try {
            const data = await chatApi.listMessages(selectedChatId, { aroundId: messageId, limit: 40 });
            setMessages(data.items || []);
            setHasMore(false);
            setFocusedMessageId(messageId);
            setIsSearchOpen(false);
            pendingScrollToBottomRef.current = false;
            window.setTimeout(() => {
                const node = document.getElementById(`chat-message-${messageId}`);
                if (node) {
                    node.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            }, 30);
        } catch (error) {
            alert(error?.details?.error || error?.message || UI_TEXT.openMessageError);
        }
    }, [selectedChatId]);

    const loadMediaBucket = useCallback(async (bucket) => {
        if (!selectedChatId) return;

        setMediaLoading(true);
        try {
            const items = await chatApi.getChatMedia(selectedChatId, bucket, 60, 0);
            setMediaItems(items);
            setMediaBucket(bucket);
        } catch (error) {
            alert(error?.details?.error || error?.message || UI_TEXT.mediaError);
        } finally {
            setMediaLoading(false);
        }
    }, [selectedChatId]);

    const openMedia = useCallback(async (bucket = 'media') => {
        setIsMediaOpen(true);
        await loadMediaBucket(bucket);
    }, [loadMediaBucket]);

    const uploadSelectedFiles = useCallback(async (fileList, options = {}) => {
        if (!selectedChatId || !fileList?.length) return;

        setUploadBusy(true);
        try {
            const message = await chatApi.uploadFiles(selectedChatId, fileList, {
                text: options.text ?? messageDraft.trim(),
                kind: options.kind,
                durationSec: options.durationSec,
                replyToMessageId: replyingToMessageId || undefined,
            });
            applyMessageMutation(message, { isNewActivity: true, forceUnreadZero: true });
            setMessageDraft('');
            setReplyingToMessageId(null);
        } catch (error) {
            alert(error?.details?.error || error?.message || UI_TEXT.uploadError);
        } finally {
            setUploadBusy(false);
            if (attachmentInputRef.current) {
                attachmentInputRef.current.value = '';
            }
        }
    }, [applyMessageMutation, messageDraft, replyingToMessageId, selectedChatId]);

    const queuePendingFiles = useCallback((fileList) => {
        const nextFiles = Array.from(fileList || []);
        if (!nextFiles.length) return;
        setPendingFiles((current) => current.concat(nextFiles));
        if (attachmentInputRef.current) attachmentInputRef.current.value = '';
    }, []);

    const removePendingFile = useCallback((index) => {
        setPendingFiles((current) => current.filter((_, itemIndex) => itemIndex !== index));
    }, []);

    const openAttachmentPicker = useCallback((accept = '') => {
        setIsAttachmentSheetOpen(false);
        if (!attachmentInputRef.current) return;
        attachmentInputRef.current.accept = accept;
        attachmentInputRef.current.click();
    }, []);

    const onAttachmentPick = useCallback((event) => {
        const fileList = Array.from(event.target.files || []);
        queuePendingFiles(fileList);
    }, [queuePendingFiles]);

    const onDropFiles = useCallback((event) => {
        event.preventDefault();
        setIsDragOver(false);
        const fileList = Array.from(event.dataTransfer?.files || []);
        queuePendingFiles(fileList);
    }, [queuePendingFiles]);

    const toggleVoiceRecording = useCallback(async () => {
        if (isRecording) {
            mediaRecorderRef.current?.stop();
            return;
        }

        if (!navigator.mediaDevices?.getUserMedia || typeof MediaRecorder === 'undefined') {
            alert(UI_TEXT.browserNoVoice);
            return;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const recorder = new MediaRecorder(stream);
            mediaChunksRef.current = [];
            recordingStreamRef.current = stream;
            recordingStartedAtRef.current = Date.now();

            recorder.ondataavailable = (event) => {
                if (event.data?.size) {
                    mediaChunksRef.current.push(event.data);
                }
            };

            recorder.onstop = async () => {
                const durationSec = Math.max(1, Math.round((Date.now() - recordingStartedAtRef.current) / 1000));
                const blob = new Blob(mediaChunksRef.current, { type: recorder.mimeType || 'audio/webm' });
                const ext = blob.type.includes('ogg') ? 'ogg' : 'webm';
                const file = new File([blob], `voice-${Date.now()}.${ext}`, { type: blob.type || 'audio/webm' });
                recordingStreamRef.current?.getTracks().forEach((track) => track.stop());
                recordingStreamRef.current = null;
                mediaRecorderRef.current = null;
                mediaChunksRef.current = [];
                setIsRecording(false);
                await uploadSelectedFiles([file], { kind: 'voice', text: '', durationSec });
            };

            recorder.start();
            mediaRecorderRef.current = recorder;
            setIsRecording(true);
        } catch (error) {
            alert(error?.message || UI_TEXT.recordError);
            recordingStreamRef.current?.getTracks().forEach((track) => track.stop());
            recordingStreamRef.current = null;
            setIsRecording(false);
        }
    }, [isRecording, uploadSelectedFiles]);

    const onSend = useCallback(async () => {
        if (!selectedChatId) return;

        const text = messageDraft.trim();
        if (!text && !pendingFiles.length) return;

        pendingScrollToBottomRef.current = true;
        shouldStickToBottomRef.current = true;
        await stopTyping();

        try {
            if (editingMessageId) {
                const message = await chatApi.editMessage(selectedChatId, editingMessageId, text);
                applyMessageMutation(message, { isNewActivity: false, forceUnreadZero: true });
                setEditingMessageId(null);
                setMessageDraft('');
                return;
            }

            setMessageDraft('');
            if (pendingFiles.length) {
                const message = await chatApi.uploadFiles(selectedChatId, pendingFiles, {
                    text,
                    replyToMessageId: replyingToMessageId || undefined,
                });
                applyMessageMutation(message, { isNewActivity: true, forceUnreadZero: true });
                setPendingFiles([]);
                setReplyingToMessageId(null);
                return;
            }

            const message = await chatApi.sendMessage(selectedChatId, text, { replyToMessageId: replyingToMessageId || undefined });
            applyMessageMutation(message, { isNewActivity: true, forceUnreadZero: true });
            setReplyingToMessageId(null);
            return;
        } catch (error) {
            alert(error?.details?.error || error?.message || (editingMessageId ? UI_TEXT.editMessageError : 'Не удалось отправить сообщение'));
        }
    }, [applyMessageMutation, editingMessageId, messageDraft, pendingFiles, replyingToMessageId, selectedChatId, stopTyping]);

    const isReadBySomeone = useCallback(
        (messageId) => {
            if (!myUserId) return false;

            return Object.values(readStates).some((state) => {
                if (!state.userId || state.userId === myUserId || !state.lastReadMessageId) return false;
                return state.lastReadMessageId >= messageId;
            });
        },
        [myUserId, readStates]
    );

    useEffect(() => {
        selectedChatIdRef.current = selectedChatId;
    }, [selectedChatId]);

    useEffect(() => {
        const onResize = () => {
            setIsMobile(getIsMobileViewport());
        };

        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => {
        if (isMobile) setMobileView((current) => (current === 'chat' ? 'chat' : 'list'));
        else setMobileView('chat');
    }, [isMobile]);

    useEffect(() => {
        void loadChats();
    }, [loadChats]);

    useEffect(() => {
        if (!selectedChatId) {
            setMessages([]);
            setMessagesReadyChatId(null);
            setHasMore(false);
            return;
        }

        setMessageDraft('');
        setSearchQuery('');
        setSearchResults([]);
        setIsSearchOpen(false);
        setIsMediaOpen(false);
        setIsSettingsOpen(false);
        setFocusedMessageId(null);
        setEditingMessageId(null);
        setReplyingToMessageId(null);
        setActiveMessageAction(null);
        setIsEmojiOpen(false);
        setIsDragOver(false);
        setActiveMediaPreview(null);
        void loadMessages(selectedChatId);
    }, [selectedChatId, loadMessages]);

    useEffect(() => {
        const onKeyDown = (event) => {
            if (event.key !== 'Escape') return;
            setActiveMessageAction(null);
            setIsForwardOpen(false);
            setForwardingMessageId(null);
            setIsSearchOpen(false);
            setIsEmojiOpen(false);
            setActiveMediaPreview(null);
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        if (!selectedChatId || messagesReadyChatId !== selectedChatId) return undefined;

        const lastMessageId = lastStreamMessageIdRef.current;
        connectStream(selectedChatId, lastMessageId);

        return () => {
            if (streamRef.current) {
                streamRef.current.close();
                streamRef.current = null;
            }
        };
    }, [selectedChatId, messagesReadyChatId, connectStream]);

    useEffect(() => {
        if (incomingCallId && callPhase === 'idle') {
            void startCallTone('incoming');
            return undefined;
        }
        if (!currentCallId) {
            stopCallTone();
        }
        return undefined;
    }, [callPhase, currentCallId, incomingCallId, startCallTone, stopCallTone]);

    useEffect(() => {
        if (currentCallRemoteConnected) {
            stopCallTone();
            if (!callConnectedAt) setCallConnectedAt(Date.now());
            return;
        }
        if (!currentCallId) {
            setCallConnectedAt(null);
            setCallElapsedSec(0);
        }
    }, [callConnectedAt, currentCallId, currentCallRemoteConnected, stopCallTone]);

    useEffect(() => {
        if (!callConnectedAt) return undefined;
        const updateElapsed = () => {
            setCallElapsedSec(Math.max(0, Math.floor((Date.now() - callConnectedAt) / 1000)));
        };
        updateElapsed();
        const timer = window.setInterval(updateElapsed, 1000);
        return () => window.clearInterval(timer);
    }, [callConnectedAt]);

    useEffect(() => {
        if (!currentCallId || callPhase === 'idle' || callPhase === 'failed' || callPhase === 'ending') return;
        if (activeCalls.some((call) => String(call.id) === String(currentCallId))) return;

        void disconnectCurrentCall();
        stopCallTone();
        setCurrentCallId(null);
        setCurrentCallSnapshot(null);
        setCallPhase('idle');
        setCallMuted(false);
        setCallError('');
        setCallConnectedAt(null);
        setCallElapsedSec(0);
    }, [activeCalls, callPhase, currentCallId, disconnectCurrentCall, stopCallTone]);

    useEffect(() => {
        if (!messages.length) return;
        void markLatestRead();
    }, [messages, markLatestRead]);

    useEffect(() => {
        return () => {
            if (longPressTimerRef.current) window.clearTimeout(longPressTimerRef.current);
            if (typingIdleTimerRef.current) window.clearTimeout(typingIdleTimerRef.current);
            if (reconnectTimerRef.current) window.clearTimeout(reconnectTimerRef.current);
            if (streamRef.current) streamRef.current.close();
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                mediaRecorderRef.current.stop();
            }
            if (recordingStreamRef.current) {
                recordingStreamRef.current.getTracks().forEach((track) => track.stop());
            }
            callToneRef.current?.stop();
            callConnectionRef.current?.disconnect?.();
        };
    }, []);

    useEffect(() => {
        if (!focusedMessageId) return undefined;

        const timer = window.setTimeout(() => setFocusedMessageId(null), 2400);
        return () => window.clearTimeout(timer);
    }, [focusedMessageId]);

    useEffect(() => {
        if (editingMessage?.isDeleted) {
            cancelEditingMessage();
        }
    }, [cancelEditingMessage, editingMessage]);

    useLayoutEffect(() => {
        const textarea = composerTextareaRef.current;
        if (!textarea) return;

        textarea.style.height = '0px';
        textarea.style.height = `${Math.min(textarea.scrollHeight, 136)}px`;
    }, [messageDraft]);

    useLayoutEffect(() => {
        const panel = messagesPanelRef.current;
        if (!panel) return;

        if (prependScrollRef.current) {
            const { previousHeight, previousTop } = prependScrollRef.current;
            panel.scrollTop = previousTop + (panel.scrollHeight - previousHeight);
            prependScrollRef.current = null;
            syncJumpButton();
            return;
        }

        if (pendingScrollToBottomRef.current || shouldStickToBottomRef.current) {
            panel.scrollTop = panel.scrollHeight;
            pendingScrollToBottomRef.current = false;
            shouldStickToBottomRef.current = true;
            setShowJumpButton(false);
            return;
        }

        syncJumpButton();
    }, [messages, syncJumpButton]);

    const shouldShowListPane = !isMobile || mobileView === 'list';
    const shouldShowChatPane = !isMobile || mobileView === 'chat';

    return (
    <MessengerWorkspace selectedChat={selectedChat} threads={chats} selectedChatId={selectedChatId} callActive={Boolean(currentCallId)} client={messengerClient} onVisibilityChange={setMessengerChatVisible} onOpenChat={(id) => { selectChat(id) }}>
        <div className="chats-page" ref={pageRef}>
            <div className={`chats-shell ${isMobile ? 'mobile' : ''}`}>
                <aside className={`chats-sidebar ${shouldShowListPane ? 'visible' : 'hidden'}`}>
                    <div className="chats-sidebar-top">
                        <div>
                            <div className="chats-brand">CHIO CHAT</div>
                            <div className="chats-sidebar-title">{UI_TEXT.messages}</div>
                        </div>

                        <button
                            type="button"
                            className="round-action primary"
                            onClick={() => setIsCreateOpen(true)}
                            aria-label={UI_TEXT.newChatTitle}
                        >
                            <Icon name="plus" />
                        </button>
                    </div>

                    <div className="chats-search-wrap">
                        <input
                            className="chats-input chats-search"
                            placeholder={UI_TEXT.search}
                            value={query}
                            onChange={(event) => setQuery(event.target.value)}
                        />
                    </div>

                    <div className="chats-filter-row">
                        {[
                            { key: 'all', label: 'Все', count: chats.length },
                            { key: 'unread', label: 'Непрочитанные', count: chats.filter((chat) => chat.unreadCount > 0).length },
                            { key: 'important', label: 'Важные', count: chats.filter((chat) => chat.isImportant).length },
                        ].map((filter) => (
                            <button
                                key={filter.key}
                                type="button"
                                className={`chat-filter-chip ${listFilter === filter.key ? 'active' : ''}`}
                                onClick={() => setListFilter(filter.key)}
                            >
                                <span>{filter.label}</span>
                                <span className="chat-filter-count">{filter.count}</span>
                            </button>
                        ))}
                    </div>

                    <div className="chats-list">
                        {loadingChats && (
                            <div className="chat-list-skeleton" aria-hidden="true">
                                {[0, 1, 2, 3, 4, 5, 6].map((item) => (
                                    <div key={item} className="chat-row-skeleton">
                                        <span className="skeleton-avatar" />
                                        <span className="skeleton-copy">
                                            <span className="skeleton-line title" />
                                            <span className="skeleton-line meta" />
                                        </span>
                                        <span className="skeleton-line time" />
                                    </div>
                                ))}
                            </div>
                        )}
                        {chatsError && <div className="chats-empty chats-error">{chatsError}</div>}
                        {!loadingChats && !chatsError && filteredChats.length === 0 && (
                            <div className="chats-empty">{UI_TEXT.noChats}</div>
                        )}

                        {hasMoreChats && chats.length >= 40 && <button type="button" disabled={moreChatsLoading} onClick={() => void loadMoreChats()}>{moreChatsLoading ? 'Загрузка…' : 'Показать ещё чаты'}</button>}
                        {filteredChats.map((chat) => {
                            const avatar = buildAvatar(chat);
                            const previewText = getMessagePreview(chat.lastMessage) || chat.preview || UI_TEXT.noMessages;

                            return (
                                <button
                                    key={chat.id}
                                    type="button"
                                    className={`chat-row ${selectedChatId === chat.id ? 'active' : ''} ${chat.isPinned ? 'pinned' : ''} ${chat.isImportant ? 'important' : ''}`}
                                    onClick={() => openChat(chat.id)}
                                >
                                    <div className="chat-avatar">{avatar.initials}</div>
                                    <div className="chat-row-body">
                                        <div className="chat-row-top">
                                            <div className="chat-row-title">{buildChatName(chat)}</div>
                                            <div className="chat-row-time">
                                                {chat.isPinned && <span className="chat-row-pin"><Icon name="pin" /></span>}
                                                {chat.isImportant && <span className="chat-row-pin important"><Icon name="star" /></span>}
                                                {chat.lastMessage ? formatChatListTime(chat.lastMessage.createdAt) : ''}
                                            </div>
                                        </div>
                                        <div className="chat-row-bottom">
                                            <div className="chat-row-preview">{previewText}</div>
                                            {chat.unreadCount > 0 && (
                                                <span className="chat-unread-badge">{chat.unreadCount}</span>
                                            )}
                                        </div>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </aside>

                <main className={`chats-main ${shouldShowChatPane ? 'visible' : 'hidden'}`}>
                    {!selectedChat && (
                        <div className={`chats-empty chats-main-empty ${selectedChatAccessError ? 'chats-error' : ''}`}>
                            {selectedChatAccessError || UI_TEXT.selectChat}
                        </div>
                    )}

                    {selectedChat && (
                        <>
                            <header className="chats-header">
                                <div className="chats-header-main">
                                    {isMobile && (
                                        <button
                                            type="button"
                                            className="icon-button"
                                            onClick={() => {
                                                setMobileView('list');
                                                if (window.location.pathname !== basePath) navigate(basePath);
                                            }}
                                            aria-label={UI_TEXT.backToChats}
                                        >
                                            <Icon name="back" />
                                        </button>
                                    )}

                                    <div className="chat-avatar large">{selectedChatAvatar.initials}</div>

                                    <div className="chats-header-text">
                                        <div className="chats-header-name">{buildChatName(selectedChat)}</div>
                                        <div className="chats-header-meta">
                                            {typingLabel || buildChatMeta(selectedChat)}
                                        </div>
                                    </div>
                                </div>

                                <div className="header-actions">
                                    {LEGACY_CALL_CONTROLS && selectedChat.canStartCall !== false && !selectedChat.isChannel && <button
                                        type="button"
                                        className={`icon-button call-header-button ${currentCallId ? 'active' : ''}`}
                                        onClick={() => void startAudioCall()}
                                        aria-label={UI_TEXT.audioCall}
                                        disabled={callBusy || Boolean(currentCallId)}
                                    >
                                        <Icon name="phone" />
                                    </button>}
                                    <button
                                        type="button"
                                        className="icon-button"
                                        onClick={() => setIsSearchOpen(true)}
                                        aria-label={UI_TEXT.searchMessages}
                                    >
                                        <Icon name="search" />
                                    </button>
                                    <button
                                        type="button"
                                        className="icon-button optional-mobile-action"
                                        onClick={() => void openMedia('media')}
                                        aria-label={UI_TEXT.openMedia}
                                    >
                                        <Icon name="media" />
                                    </button>
                                    <button
                                        type="button"
                                        className="icon-button"
                                        onClick={() => void openSettings()}
                                        aria-label={UI_TEXT.openSettings}
                                    >
                                        <Icon name="settings" />
                                    </button>
                                    <button
                                        type="button"
                                        className="icon-button optional-mobile-action"
                                        onClick={() => setIsInviteOpen(true)}
                                        aria-label={UI_TEXT.inviteParticipant}
                                    >
                                        <Icon name="addUser" />
                                    </button>
                                </div>
                            </header>

                            {incomingCall && !currentCallId && (
                                <div className="chat-call-panel incoming">
                                    <div className="chat-call-avatar">
                                        <Icon name="phone" />
                                    </div>
                                    <div className="chat-call-copy">
                                        <strong>{UI_TEXT.incomingCall}</strong>
                                        <span>{UI_TEXT.callFrom}: {currentCallPeerLabel}</span>
                                        {callSoundBlocked && (
                                            <button type="button" className="chat-call-sound" onClick={() => void enableCallSound()}>
                                                {UI_TEXT.callSoundBlocked}
                                            </button>
                                        )}
                                    </div>
                                    <div className="chat-call-actions">
                                        <button type="button" className="call-action accept" onClick={() => void answerIncomingCall()} disabled={callBusy}>
                                            <Icon name="phone" />
                                            <span>{UI_TEXT.answerCall}</span>
                                        </button>
                                        <button type="button" className="call-action decline" onClick={() => void declineIncomingCall()} disabled={callBusy}>
                                            <Icon name="phoneOff" />
                                            <span>{UI_TEXT.declineCall}</span>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {currentCall && currentCallId && (
                                <div className={`chat-call-panel active ${currentCallRemoteConnected ? 'connected' : 'ringing'} ${callPhase === 'failed' ? 'failed' : ''}`}>
                                    <div className="chat-call-avatar">
                                        <Icon name={callPhase === 'failed' ? 'phoneOff' : 'phone'} />
                                    </div>
                                    <div className="chat-call-copy">
                                        <strong>
                                            {currentCall.initiatorUserId === myUserId ? UI_TEXT.callTo : UI_TEXT.callFrom}: {currentCallPeerLabel}
                                        </strong>
                                        <span>{callStatusLabel || UI_TEXT.callConnecting}</span>
                                        {callSoundBlocked && !currentCallRemoteConnected && (
                                            <button type="button" className="chat-call-sound" onClick={() => void enableCallSound()}>
                                                {UI_TEXT.callSoundBlocked}
                                            </button>
                                        )}
                                    </div>
                                    <div className="chat-call-actions">
                                        <button
                                            type="button"
                                            className={`call-action muted ${callMuted ? 'active' : ''}`}
                                            onClick={() => void toggleCallMute()}
                                            disabled={callBusy || !callConnectionRef.current}
                                            aria-label={callMuted ? UI_TEXT.unmuteCall : UI_TEXT.muteCall}
                                        >
                                            <Icon name={callMuted ? 'micOff' : 'mic'} />
                                            <span>{callMuted ? UI_TEXT.unmuteCall : UI_TEXT.muteCall}</span>
                                        </button>
                                        <button type="button" className="call-action" onClick={() => void toggleScreenSharing()} disabled={callBusy || !callConnectionRef.current}>{screenSharing ? 'Остановить показ' : 'Показать экран'}</button>
                                        <button type="button" className="call-action" onClick={() => void callConnectionRef.current?.resumeAudio()}>Включить звук</button>
                                        <button type="button" className="call-action decline" onClick={() => void endCurrentCall()} disabled={callBusy}>
                                            <Icon name="phoneOff" />
                                            <span>{UI_TEXT.endCall}</span>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {screenTracks.length > 0 && <div className="chat-screen-grid">{screenTracks.map(entry => <CallScreenTrack key={entry.id} entry={entry} />)}</div>}
                            {latestPinnedMessage?.message && (
                                <button
                                    type="button"
                                    className="pinned-message-bar"
                                    onClick={() => void jumpToMessage(latestPinnedMessage.message.id)}
                                >
                                    <span className="pinned-message-icon"><Icon name="pin" /></span>
                                    <span className="pinned-message-copy">
                                        <strong>Закрепленные сообщения{pinnedMessages.length > 1 ? ` · ${pinnedMessages.length}` : ''}</strong>
                                        <span>{getMessagePreview(latestPinnedMessage.message)}</span>
                                    </span>
                                </button>
                            )}

                            <section
                                className={`messages-panel ${isDragOver ? 'drag-over' : ''}`}
                                ref={messagesPanelRef}
                                onScroll={() => { syncJumpButton(); void markLatestRead(); }}
                                onDragOver={(event) => {
                                    event.preventDefault();
                                    setIsDragOver(true);
                                }}
                                onDragLeave={(event) => {
                                    if (event.currentTarget === event.target) setIsDragOver(false);
                                }}
                                onDrop={(event) => void onDropFiles(event)}
                            >
                                {messagesLoading && messages.length === 0 && (
                                    <div className="message-list-skeleton" aria-hidden="true">
                                        <span className="skeleton-date-pill" />
                                        {[0, 1, 2, 3, 4, 5].map((item) => (
                                            <span key={item} className={`message-skeleton-bubble ${item % 3 === 1 ? 'mine' : 'other'} ${item % 2 === 0 ? 'wide' : ''}`}>
                                                <span className="skeleton-line message-line" />
                                                <span className="skeleton-line message-line short" />
                                            </span>
                                        ))}
                                    </div>
                                )}
                                {messagesError && <div className="chats-empty chats-error">{messagesError}</div>}

                                {!messagesLoading && hasMore && messages.length > 0 && (
                                    <div className="messages-loadmore-wrap">
                                        <button
                                            type="button"
                                            className="messages-loadmore"
                                            onClick={() => void loadMessages(selectedChat.id, messages[0]?.id)}
                                        >
                                            {UI_TEXT.showPrevious}
                                        </button>
                                    </div>
                                )}

                                {!messagesLoading && messages.length === 0 && (
                                    <div className="chats-empty">{UI_TEXT.noMessagesYet}</div>
                                )}

                                {messageItems.map((message) => (
                                    <React.Fragment key={message.id}>
                                        {message.showDateDivider && (
                                            <div className="messages-date-divider">
                                                <span>{message.dateLabel}</span>
                                            </div>
                                        )}

                                        <div
                                            id={`chat-message-${message.id}`}
                                            className={`message-row ${message.mine ? 'mine' : 'other'} ${
                                                message.startsGroup ? 'starts-group' : ''
                                            } ${message.endsGroup ? 'ends-group' : ''} ${
                                                message.isFocused ? 'focused' : ''
                                            }`}
                                        >
                                            {message.showAuthor && (
                                                <div className="message-author">{message.authorLabel}</div>
                                            )}

                                            <article
                                                className={`message-bubble ${message.mine ? 'mine' : 'other'} ${
                                                    message.isDeleted ? 'deleted' : ''
                                                } ${message.isPinned ? 'pinned' : ''} ${message.isImportantForMe ? 'important' : ''}`}
                                                onDoubleClick={() => startReplyMessage(message)}
                                                onTouchStart={() => queueMessageActionSheet(message)}
                                                onTouchEnd={clearLongPress}
                                                onTouchMove={clearLongPress}
                                                onTouchCancel={clearLongPress}
                                            >
                                                <MessageContent message={message} onOpenMedia={setActiveMediaPreview} />
                                                <div className="message-meta">
                                                    <span>{formatTime(message.createdAt)}</span>
                                                    {message.isPinned && <span className="message-pin-mark"><Icon name="pin" /></span>}
                                                    {message.isImportantForMe && <span className="message-pin-mark important"><Icon name="star" /></span>}
                                                    {message.editedAt && !message.isDeleted && (
                                                        <span className="message-edited-mark">{UI_TEXT.edited}</span>
                                                    )}
                                                    {message.mine && (
                                                        <span
                                                            className={`message-status ${
                                                                isReadBySomeone(message.id) ? 'read' : 'sent'
                                                            }`}
                                                            aria-label={
                                                                isReadBySomeone(message.id)
                                                                    ? UI_TEXT.read
                                                                    : UI_TEXT.sent
                                                            }
                                                        >
                                                            {isReadBySomeone(message.id) ? '✓✓' : '✓'}
                                                        </span>
                                                    )}
                                                    {!isMobile && !message.isDeleted && (
                                                        <span className="message-meta-actions">
                                                            <button
                                                                type="button"
                                                                className="message-action-button"
                                                                onClick={() => startReplyMessage(message)}
                                                                aria-label="Ответить"
                                                                title="Ответить"
                                                            >
                                                                <Icon name="reply" />
                                                            </button>
                                                            {message.canEdit && (
                                                                <button
                                                                    type="button"
                                                                    className="message-action-button"
                                                                    onClick={() => startEditingMessage(message)}
                                                                    aria-label={UI_TEXT.editMessage}
                                                                    title={UI_TEXT.editMessage}
                                                                >
                                                                    <Icon name="edit" />
                                                                </button>
                                                            )}
                                                            {message.canDelete && (
                                                                <button
                                                                    type="button"
                                                                    className="message-action-button danger"
                                                                    onClick={() => void handleDeleteMessage(message)}
                                                                    aria-label={UI_TEXT.deleteMessage}
                                                                    title={UI_TEXT.deleteMessage}
                                                                >
                                                                    <Icon name="trash" />
                                                                </button>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="message-action-button"
                                                                onClick={() => setActiveMessageAction(message)}
                                                                aria-label={UI_TEXT.messageActions}
                                                                title={UI_TEXT.messageActions}
                                                            >
                                                                <Icon name="settings" />
                                                            </button>
                                                        </span>
                                                    )}
                                                </div>
                                            </article>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </section>

                            {showJumpButton && (
                                <button
                                    type="button"
                                    className="jump-to-bottom"
                                    onClick={() => scrollToBottom('smooth')}
                                    aria-label={UI_TEXT.jumpToLatest}
                                >
                                    <Icon name="down" />
                                </button>
                            )}

                            <footer className="composer">
                                {replyingToMessage && !editingMessage && (
                                    <div className="composer-editing reply">
                                        <div className="composer-editing-copy">
                                            <strong>Ответ</strong>
                                            <span>{getMessagePreview(replyingToMessage)}</span>
                                        </div>
                                        <button
                                            type="button"
                                            className="composer-editing-cancel"
                                            onClick={() => setReplyingToMessageId(null)}
                                        >
                                            {UI_TEXT.cancelEdit}
                                        </button>
                                    </div>
                                )}
                                {editingMessage && (
                                    <div className="composer-editing">
                                        <div className="composer-editing-copy">
                                            <strong>{UI_TEXT.editingMessage}</strong>
                                            <span>{editingMessage.text || UI_TEXT.message}</span>
                                        </div>
                                        <button
                                            type="button"
                                            className="composer-editing-cancel"
                                            onClick={cancelEditingMessage}
                                        >
                                            {UI_TEXT.cancelEdit}
                                        </button>
                                    </div>
                                )}
                                {!editingMessage && pendingFiles.length > 0 && (
                                    <div className="composer-attachments">
                                        {pendingFiles.map((file, index) => (
                                            <div className="composer-attachment-chip" key={`${file.name}-${file.size}-${index}`}>
                                                <span>
                                                    <strong>{file.name}</strong>
                                                    <em>{formatFileSize(file.size)}</em>
                                                </span>
                                                <button type="button" onClick={() => removePendingFile(index)} aria-label="Убрать вложение">
                                                    <Icon name="close" />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="composer-shell">
                                    <input
                                        ref={attachmentInputRef}
                                        type="file"
                                        multiple
                                        className="composer-file-input"
                                        onChange={(event) => void onAttachmentPick(event)}
                                    />
                                    <button
                                        type="button"
                                        className="composer-tool"
                                        onClick={() => setIsAttachmentSheetOpen(true)}
                                        disabled={uploadBusy || Boolean(editingMessageId)}
                                        aria-label={UI_TEXT.attachFiles}
                                    >
                                        <Icon name="attach" />
                                    </button>
                                    <button
                                        type="button"
                                        className="composer-tool"
                                        onClick={() => setIsEmojiOpen((current) => !current)}
                                        disabled={uploadBusy}
                                        aria-label="Emoji"
                                    >
                                        ☺
                                    </button>
                                    <textarea
                                        ref={composerTextareaRef}
                                        className="composer-input"
                                        placeholder={UI_TEXT.message}
                                        rows={1}
                                        value={messageDraft}
                                        onChange={(event) => {
                                            setMessageDraft(event.target.value);
                                            void sendTyping();
                                        }}
                                        onBlur={() => {
                                            void stopTyping();
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' && !event.shiftKey) {
                                                event.preventDefault();
                                                void onSend();
                                            }
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className={`composer-tool ${isRecording ? 'recording' : ''}`}
                                        onClick={() => void toggleVoiceRecording()}
                                        disabled={uploadBusy || Boolean(editingMessageId)}
                                        aria-label={isRecording ? UI_TEXT.stopRecording : UI_TEXT.recordVoice}
                                    >
                                        <Icon name={isRecording ? 'stop' : 'mic'} />
                                    </button>
                                    <button
                                        type="button"
                                        className="composer-send"
                                        onClick={() => void onSend()}
                                        disabled={(!messageDraft.trim() && pendingFiles.length === 0) || uploadBusy}
                                        aria-label={editingMessageId ? UI_TEXT.save : UI_TEXT.send}
                                        title={editingMessageId ? UI_TEXT.save : UI_TEXT.send}
                                    >
                                        {uploadBusy ? '...' : <Icon name="send" />}
                                    </button>
                                </div>
                                {isEmojiOpen && (
                                    <div className="emoji-panel">
                                        {['👍', '❤️', '🔥', '👏', '😁', '😮', '😢', '🙏'].map((emoji) => (
                                            <button
                                                key={emoji}
                                                type="button"
                                                className="emoji-choice"
                                                onClick={() => {
                                                    setMessageDraft((current) => current + emoji);
                                                    composerTextareaRef.current?.focus();
                                                }}
                                            >
                                                {emoji}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </footer>
                        </>
                    )}
                </main>
            </div>

            <ModalSheet
                open={Boolean(activeMessageAction)}
                title={UI_TEXT.messageActions}
                onClose={() => setActiveMessageAction(null)}
            >
                <div className="sheet-form">
                    {activeMessageAction && !activeMessageAction.isDeleted && (
                        <>
                            <div className="reaction-row">
                                {['👍', '❤️', '🔥', '👏', '😁', '🙏'].map((reaction) => (
                                    <button key={reaction} type="button" className="reaction-choice" onClick={() => void reactToMessage(activeMessageAction, reaction)}>
                                        {reaction}
                                    </button>
                                ))}
                            </div>
                            <button type="button" className="sheet-secondary" onClick={() => startReplyMessage(activeMessageAction)}>
                                <Icon name="reply" />
                                <span>Ответить</span>
                            </button>
                            <button type="button" className="sheet-secondary" onClick={() => void copyMessage(activeMessageAction)}>
                                <Icon name="copy" />
                                <span>Копировать</span>
                            </button>
                            <button type="button" className="sheet-secondary" onClick={() => openForwardMessage(activeMessageAction)}>
                                <Icon name="forward" />
                                <span>Переслать</span>
                            </button>
                            <button type="button" className="sheet-secondary" onClick={() => void toggleMessagePin(activeMessageAction)}>
                                <Icon name="pin" />
                                <span>{activeMessageAction.isPinned ? 'Открепить' : 'Закрепить'}</span>
                            </button>
                            <button type="button" className="sheet-secondary" onClick={() => void toggleMessageImportant(activeMessageAction)}>
                                <Icon name="star" />
                                <span>{activeMessageAction.isImportantForMe ? 'Убрать из важных' : 'Отметить важным'}</span>
                            </button>
                        </>
                    )}
                    {activeMessageAction?.canEdit && (
                        <button
                            type="button"
                            className="sheet-secondary"
                            onClick={() => startEditingMessage(activeMessageAction)}
                        >
                            <Icon name="edit" />
                            <span>{UI_TEXT.editMessage}</span>
                        </button>
                    )}
                    {activeMessageAction?.canDelete && (
                        <button
                            type="button"
                            className="sheet-secondary danger"
                            onClick={() => void handleDeleteMessage(activeMessageAction)}
                        >
                            <Icon name="trash" />
                            <span>{UI_TEXT.deleteMessage}</span>
                        </button>
                    )}
                    <button type="button" className="sheet-secondary" onClick={() => setActiveMessageAction(null)}>
                        <Icon name="close" />
                        <span>{UI_TEXT.cancelEdit}</span>
                    </button>
                </div>
            </ModalSheet>

            <ModalSheet open={isForwardOpen} title="Переслать" onClose={() => { setIsForwardOpen(false); setForwardingMessageId(null); }}>
                <div className="sheet-form forward-list">
                    {sortChatsByActivity(chats).map((chat) => {
                        const avatar = buildAvatar(chat);
                        return (
                            <button key={chat.id} type="button" className="forward-chat-row" onClick={() => void forwardMessageToChat(chat)}>
                                <span className="chat-avatar small">{avatar.initials}</span>
                                <span>{buildChatName(chat)}</span>
                            </button>
                        );
                    })}
                </div>
            </ModalSheet>

            <ModalSheet open={isSearchOpen} title={UI_TEXT.searchMessages} onClose={() => setIsSearchOpen(false)}>
                <div className="sheet-form">
                    <div className="search-row">
                        <input
                            className="chats-input"
                            placeholder={UI_TEXT.findMessages}
                            value={searchQuery}
                            onChange={(event) => setSearchQuery(event.target.value)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    void searchInsideChat();
                                }
                            }}
                        />
                        <button type="button" className="sheet-primary compact" onClick={() => void searchInsideChat()}>
                            {UI_TEXT.searchAction}
                        </button>
                    </div>

                    <div className="sheet-results">
                        {searchBusy && <div className="chats-empty">{UI_TEXT.searching}</div>}
                        {!searchBusy && searchResults.length === 0 && <div className="chats-empty">{UI_TEXT.noResultsYet}</div>}
                        {searchCursor && <button disabled={searchBusy} type="button" onClick={() => void searchInsideChat(true)}>Показать ещё результаты</button>}
                        {searchResults.map((item) => (
                            <button
                                key={item.id}
                                type="button"
                                className="sheet-result"
                                onClick={() => void jumpToMessage(item.id)}
                            >
                                <div className="sheet-result-title">{getMessagePreview(item)}</div>
                                <div className="sheet-result-meta">
                                    {formatDateLabel(item.createdAt)} {formatTime(item.createdAt)}
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </ModalSheet>

            <ModalSheet open={isMediaOpen} title={UI_TEXT.chatMedia} onClose={() => setIsMediaOpen(false)}>
                <div className="media-tabs">
                    {[
                        ['media', UI_TEXT.media],
                        ['files', UI_TEXT.files],
                        ['links', UI_TEXT.links],
                    ].map(([bucket, label]) => (
                        <button
                            key={bucket}
                            type="button"
                            className={`media-tab ${mediaBucket === bucket ? 'active' : ''}`}
                            onClick={() => void loadMediaBucket(bucket)}
                        >
                            {label}
                        </button>
                    ))}
                </div>
                <div className="media-list">
                    {mediaLoading && <div className="chats-empty">{UI_TEXT.loading}</div>}
                    {!mediaLoading && mediaItems.length === 0 && <div className="chats-empty">{UI_TEXT.noItems}</div>}
                    {!mediaLoading && mediaBucket === 'links' && mediaItems.map((item) => (
                        <div key={item.id} className="media-list-item">
                            <div className="sheet-result-title">{item.text || UI_TEXT.links}</div>
                            {(item.links || []).map((link) => (
                                <a key={link} href={link} target="_blank" rel="noreferrer" className="message-link">
                                    {link}
                                </a>
                            ))}
                        </div>
                    ))}
                    {!mediaLoading && mediaBucket !== 'links' && mediaItems.map((item) => (
                        <div key={item.id} className="media-list-item">
                                        <AttachmentPreview attachment={item} onOpenMedia={setActiveMediaPreview} />
                        </div>
                    ))}
                </div>
            </ModalSheet>

            <ModalSheet open={isSettingsOpen} title={UI_TEXT.settings} onClose={() => setIsSettingsOpen(false)}>
                <div className="sheet-form">
                    {settingsLoading && <div className="chats-empty">{UI_TEXT.loadingSettings}</div>}
                    {!settingsLoading && settingsDraft && (
                        <>
                            <input
                                className="chats-input"
                                placeholder={UI_TEXT.chatTitle}
                                value={chatSettings?.title || ''}
                                onChange={(event) =>
                                    setChatSettings((current) => ({ ...(current || {}), title: event.target.value }))
                                }
                            />
                            <label className="settings-row">
                                <span>{UI_TEXT.muteNotifications}</span>
                                <input
                                    type="checkbox"
                                    checked={Boolean(settingsDraft.isMuted)}
                                    onChange={(event) =>
                                        setSettingsDraft((current) => ({
                                            ...(current || {}),
                                            isMuted: event.target.checked,
                                            mutedUntil: event.target.checked ? current?.mutedUntil || null : null,
                                        }))
                                    }
                                />
                            </label>
                            <div className="settings-status">{getMuteStatusLabel(settingsDraft)}</div>
                            <div className="settings-mute-options">
                                {[
                                    { label: '1 час', period: 'hour' },
                                    { label: '8 часов', period: 'eight-hours' },
                                    { label: 'До завтра', period: 'tomorrow' },
                                    { label: 'Навсегда', period: 'forever' },
                                ].map((item) => (
                                    <button
                                        key={item.period}
                                        type="button"
                                        className="counter-chip"
                                        onClick={() =>
                                            setSettingsDraft((current) => ({
                                                ...(current || {}),
                                                isMuted: true,
                                                mutedUntil: getMuteUntilIso(item.period),
                                            }))
                                        }
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                            <label className="settings-row">
                                <span>Закрепить чат</span>
                                <input
                                    type="checkbox"
                                    checked={Boolean(settingsDraft.isPinned)}
                                    onChange={(event) =>
                                        setSettingsDraft((current) => ({ ...(current || {}), isPinned: event.target.checked }))
                                    }
                                />
                            </label>
                            <label className="settings-row">
                                <span>Важный чат</span>
                                <input
                                    type="checkbox"
                                    checked={Boolean(settingsDraft.isImportant)}
                                    onChange={(event) =>
                                        setSettingsDraft((current) => ({ ...(current || {}), isImportant: event.target.checked }))
                                    }
                                />
                            </label>
                            <div className="settings-counters">
                                {[
                                    ['media', UI_TEXT.media],
                                    ['files', UI_TEXT.files],
                                    ['links', UI_TEXT.links],
                                ].map(([bucket, label]) => (
                                    <button
                                        key={bucket}
                                        type="button"
                                        className="counter-chip"
                                        onClick={() => void openMedia(bucket)}
                                    >
                                        {label}: {chatSettings?.mediaCounters?.[bucket] ?? 0}
                                    </button>
                                ))}
                            </div>
                            <button
                                type="button"
                                className="sheet-primary"
                                onClick={() => void saveSettings()}
                                disabled={settingsBusy}
                            >
                                {settingsBusy ? UI_TEXT.saving : UI_TEXT.saveSettings}
                            </button>
                        </>
                    )}
                </div>
            </ModalSheet>

            <ModalSheet open={isCreateOpen} title={UI_TEXT.newChatTitle} onClose={() => setIsCreateOpen(false)}>
                <div className="sheet-form">
                    <input
                        className="chats-input"
                        placeholder={UI_TEXT.phone}
                        value={createPhone}
                        onChange={(event) => setCreatePhone(event.target.value)}
                    />
                    <input
                        className="chats-input"
                        placeholder={UI_TEXT.chatTitleOptional}
                        value={createTitle}
                        onChange={(event) => setCreateTitle(event.target.value)}
                    />
                    <button
                        type="button"
                        className="sheet-primary"
                        onClick={() => void onCreateChat()}
                        disabled={createBusy || !createPhone.trim()}
                    >
                        {createBusy ? UI_TEXT.creating : UI_TEXT.createChat}
                    </button>
                </div>
            </ModalSheet>

            <ModalSheet open={isInviteOpen} title={UI_TEXT.inviteParticipant} onClose={() => setIsInviteOpen(false)}>
                <div className="sheet-form">
                    <input
                        className="chats-input"
                        placeholder={UI_TEXT.phone}
                        value={invitePhone}
                        onChange={(event) => setInvitePhone(event.target.value)}
                    />
                    <button
                        type="button"
                        className="sheet-primary"
                        onClick={() => void onInvite()}
                        disabled={inviteBusy || !invitePhone.trim()}
                    >
                        {inviteBusy ? UI_TEXT.adding : UI_TEXT.addParticipant}
                    </button>
                </div>
            </ModalSheet>

            {isAttachmentSheetOpen && (
                <div className="chat-sheet attachment-action-sheet" role="dialog" aria-modal="true" onClick={() => setIsAttachmentSheetOpen(false)}>
                    <div className="attachment-sheet-grid" onClick={(event) => event.stopPropagation()}>
                        {[
                            { label: 'Фото', icon: 'media', color: 'blue', accept: 'image/*' },
                            { label: 'Камера', icon: 'media', color: 'purple', accept: 'image/*' },
                            { label: 'Файл', icon: 'file', color: 'orange', accept: '' },
                            { label: 'Опрос', icon: 'settings', color: 'orange', accept: '' },
                            { label: 'Документ', icon: 'file', color: 'blue', accept: '' },
                        ].map((item) => (
                            <button key={item.label} type="button" onClick={() => openAttachmentPicker(item.accept)}>
                                <span className={`attachment-sheet-icon ${item.color}`}><Icon name={item.icon} /></span>
                                <strong>{item.label}</strong>
                            </button>
                        ))}
                    </div>
                    <button className="attachment-sheet-cancel" type="button" onClick={() => setIsAttachmentSheetOpen(false)}>Отмена</button>
                </div>
            )}

            {activeMediaPreview && (
                <div className="chats-lightbox" role="dialog" aria-modal="true" onClick={() => setActiveMediaPreview(null)}>
                    <div className="chats-lightbox-content" onClick={(event) => event.stopPropagation()}>
                        <button type="button" className="chats-lightbox-close" onClick={() => setActiveMediaPreview(null)} aria-label={UI_TEXT.close}>
                            <Icon name="close" />
                        </button>
                        <img className="chats-lightbox-image" src={activeMediaPreview.url} alt={activeMediaPreview.title || UI_TEXT.openMedia} />
                        {activeMediaPreview.title && <div className="chats-lightbox-caption">{activeMediaPreview.title}</div>}
                    </div>
                </div>
            )}

            {toastMessage && <div className="chat-toast" role="status">{toastMessage}</div>}
        </div>
    </MessengerWorkspace>
    );
};

export default ChatsPage;
